import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Modal,
  Button,
  Nav,
  Offcanvas,
  Tab,
  Tabs,
} from "react-bootstrap";
import {
  FaArrowRight,
  FaCalendarCheck,
  FaUser,
  FaUserMd,
  FaHospital,
  FaPhone,
  FaBars,
  FaTimes,
  FaMapMarkerAlt,
  FaChevronDown,
  FaChevronUp,
  FaWhatsapp,
  FaEnvelope,
  FaAmbulance,
  FaHeartbeat,
  FaClock,
  FaShieldAlt,
  FaStar,
  FaQuoteLeft,
  FaQuoteRight,
  FaChevronRight,
  FaChevronLeft,
  FaCheck,
  FaStethoscope,
  FaLungs,
  FaChild,
  FaAppleAlt,
  FaVial,
  FaEye,
  FaFemale,
  FaBrain,
  FaFlask,
  FaCode,
  FaLaptopCode,
  FaGlobe,
  FaGlasses,
  FaLowVision,
  FaSearch,
  FaPlay,
  FaPause,
  FaGraduationCap,
  FaAward,
  FaHandHoldingHeart,
  FaRocket,
  FaExternalLinkAlt,
} from "react-icons/fa";
import emailjs from "@emailjs/browser";
import Quick from "./Quick.js";
import { db } from "../firebase/config.js";
import { collection, addDoc, query, orderBy, onSnapshot, serverTimestamp } from "firebase/firestore";

import { motion, AnimatePresence } from "framer-motion";
import monImage1 from "./Assets/4530b381-f925-454c-bd19-cc468d625013.jpeg";
import monImage2 from "./Assets/WhatsApp Image 2025-03-05 at 16.33.21 (1).jpeg";
import monImage3 from "./Assets/WhatsApp Image 2025-03-05 at 16.33.21 (2).jpeg";
import monImage4 from "./Assets/WhatsApp Image 2025-03-05 at 16.33.21 (3).jpeg";
import monImage5 from "./Assets/WhatsApp Image 2025-03-05 at 16.33.21 (5).jpeg";

import monImage6 from "./Assets/8b6926f4-04c7-4f86-a65c-9639b3c309d0.jpeg";
import monImage7 from "./Assets/20f0aa2c-576c-4f7f-94c1-5d12e8f122c2.jpeg";
import monImage8 from "./Assets/96eb075b-2c75-403d-8293-dc8a061b9cf2.jpeg";
import monImage9 from "./Assets/854e05e1-155e-4451-9d3f-2209ccee4bfc.jpeg";
import monImage10 from "./Assets/4530b381-f925-454c-bd19-cc468d625013.jpeg";
import monImage11 from "./Assets/5371ce22-af80-47c4-9bc1-2257dfe711db.jpeg";

import monImage12 from "./Assets/snacks.jpg";
import monImage13 from "./Assets/pmgsLo.jpg";
import monImage14 from "./Assets/ac.jpg";
import monImage15 from "./Assets/ac2.jpeg";
import monImage16 from "./Assets/ac3.jpeg";
import monImage17 from "./Assets/ac4.jpeg";
import monImage18 from "./Assets/ac5.jpeg";
import monImage19 from "./Assets/ac6.jpeg";
import monImage20 from "./Assets/ac7.jpeg";
import monImage21 from "./Assets/ac8.jpeg";
import monImage22 from "./Assets/ac9.jpeg";
import monImage23 from "./Assets/ac10.jpeg";
import monImage24 from "./Assets/ac11.jpeg";
import monImage25 from "./Assets/ac12.jpeg";
import monImage26 from "./Assets/ac13.jpeg";
import monImage27 from "./Assets/ac14.jpeg";
import monImage28 from "./Assets/ac15.jpeg";
import monImage29 from "./Assets/ac16.jpeg";
import monImage30 from "./Assets/ac17.jpeg";
import monImage31 from "./Assets/ac18.jpeg";
import monImage32 from "./Assets/ac19.jpeg";
import monImage33 from "./Assets/ac20.jpeg";
import monImage34 from "./Assets/ac21.jpeg";
import monImage35 from "./Assets/ac22.jpeg";
import monImage36 from "./Assets/ac23.jpeg";
import monImage37 from "./Assets/ac24.jpeg";
import monImage38 from "./Assets/ac25.jpeg";
import monImage39 from "./Assets/ac26.jpeg";
import monImage039 from "./Assets/ac27.jpeg";
import monImage040 from "./Assets/ac32.jpeg";





import monImage40 from "./Assets/cardiologie.jpg";
import monImage41 from "./Assets/se1.jpg";
import monImage42 from "./Assets/se2.jpg";
import monImage43 from "./Assets/se3.jpg";
import monImage44 from "./Assets/se4.jpg";
import monImage45 from "./Assets/sgem1.jpg";
import monImage46 from "./Assets/sgem2.jpg";
import monImage046 from "./Assets/sgem3.jpg";
import monImage47 from "./Assets/spd1.jpg";
import monImage48 from "./Assets/spd2.jpg";
import monImage49 from "./Assets/spd3.jpg";
import monImage50 from "./Assets/spd4.jpg";
import monImage51 from "./Assets/spp1.jpg";
import monImage52 from "./Assets/spp2.jpg";
import monImage53 from "./Assets/srpdc1.jpg";
import monImage54 from "./Assets/srpdc2.jpg";
import monImage55 from "./Assets/her1.jpg";
import monImage56 from "./Assets/her2.jpg";




import logoplateau01 from "./logoplateau01.png";

const Home = () => {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const [activeTab, setActiveTab] = useState("all");
  const heroRef = useRef(null);
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  const [activeDevTeamMember, setActiveDevTeamMember] = useState(0);
  const [activeImageCarousel, setActiveImageCarousel] = useState(0);
  const imageCarouselRef = useRef(null);
  const [activeSpecialtyIndex, setActiveSpecialtyIndex] = useState(0);
  const [isSpecialtyAutoPlay, setIsSpecialtyAutoPlay] = useState(true);
  const [showAllServices, setShowAllServices] = useState(false);

  // États pour la section commentaires
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState({
    name: '',
    email: '',
    message: '',
    rating: 5
  });
  const [commentSubmitting, setCommentSubmitting] = useState(false);
  const [commentMessage, setCommentMessage] = useState({ text: '', type: '' });

  // État pour le modal d'image snack healthy
  const [showImageModal, setShowImageModal] = useState(false);

  // Fonction pour ouvrir le modal d'image
  const handleOpenImageModal = () => {
    setShowImageModal(true);
  };

  // Fonction pour fermer le modal d'image
  const handleCloseImageModal = () => {
    setShowImageModal(false);
  };

  // Liste complète des prestations médicales avec couleurs et descriptions améliorées
  const medicalServices = [
    {
      category: "cardiologie",
      name: "Cardiologie",
      doctors: ["Dr Nancy F. SENGHOR"],
      icon: <FaHeartbeat />,
      color: "#e74c3c",
      gradient: "linear-gradient(135deg, #e74c3c, #c0392b)",
      image: monImage40,
      features: ["Consultation cardiologique", "ECG", "Échocardiographie transthoracique", "MAPA (Mesure ambulatoire de la pression artérielle)", "Holter ECG", "Test d'effort"]
    },
    {
      category: "readaptation",
      name: "Réadaptation Cardiovasculaire",
      doctors: ["Équipe spécialisée"],
      icon: <FaHeartbeat />,
      color: "#e67e22",
      gradient: "linear-gradient(135deg, #e67e22, #d35400)",
      image: monImage039,  
      features: ["Réentraînement à l'effort", "Renforcement musculaire", "Éducation thérapeutique"]
    },
    {
      category: "chirurgie",
      name: "Chirurgie Cardio-Vasculaire",
      doctors: ["Dr Papa Amath DIAGNE"],
      icon: <FaHeartbeat />,
      color: "#c0392b",
      gradient: "linear-gradient(135deg, #c0392b, #a93226)",
      image: monImage42,
      features: ["Consultation chirurgie cardiaque", "Consultation chirurgie vasculaire périphérique", "Consultation chirurgie thoracique", "Doppler crayon"]
    },
    {
      category: "pneumologie",
      name: "Pneumologie - Spirométrie - Fibroscopie bronchique",
      doctors: ["Dr Papa Masserigne SOUMARE"],
      icon: <FaLungs />,
      color: "#3498db",
      gradient: "linear-gradient(135deg, #3498db, #2980b9)",
      image: monImage51,
      features: ["Consultation", "Spirométrie", "Fibroscopie bronchique", "Tests allergologiques"]
    },
    {
      category: "gastro",
      name: "Gastro-Entérologie & Endoscopie Digestive",
      doctors: ["Dr Coumba Ndaw DIAGNE"],
      icon: <FaStethoscope />,
      color: "#9b59b6",
      gradient: "linear-gradient(135deg, #9b59b6, #8e44ad)",
      image: monImage41,
      features: ["Consultation", "Fibroscopie", "Coloscopie"]
    },
    {
      category: "pediatrie",
      name: "Pédiatrie - Endocrinologie",
      doctors: ["Dr Ginette NDONG", "Dr Aminata MBAYE"],
      icon: <FaChild />,
      color: "#2ecc71",
      gradient: "linear-gradient(135deg, #2ecc71, #27ae60)",
      image: monImage56,
      features: ["Consultation pédiatrique", "Vaccination", "Endocrinologie pédiatrique"]
    },
    {
      category: "nutrition",
      name: "Nutrition - Nutrithérapie",
      doctors: ["Équipe spécialisée"],
      icon: <FaAppleAlt />,
      color: "#27ae60",
      gradient: "linear-gradient(135deg, #27ae60, #229954)",
      image: monImage49,
      features: ["Bilan nutritionnel", "Régimes thérapeutiques", "Suivi diététique", "Éducation alimentaire"]
    },
    {
      category: "diabetologie",
      name: "Diabétologie",
      doctors: ["Pr Maïmouna NDOUR MBAYE", "Dr Ibrahima Mané DIALLO", "Dr Mathilde SARR"],
      icon: <FaVial />,
      color: "#f1c40f",
      gradient: "linear-gradient(135deg, #f1c40f, #f39c12)",
      image: monImage54,
      features: ["Consultation endocrino diabétologie", "Obésité", "Nutrition", "Pathologies de la thyroïde", "Ménopause"]
    },
    {
      category: "gynecologie",
      name: "Gynécologie",
      doctors: ["Pr Marie Edouard FAYE DIEME", "Dr Odette SARR FAYE"],
      icon: <FaFemale />,
      color: "#e84393",
      gradient: "linear-gradient(135deg, #e84393, #d63384)",
      image: monImage46,
      features: ["Consultations gynécologiques", "Suivi prénatal", "Échographie gynécologique et obstétricale", "Infertilité", "Contraception"]
    },
    {
      category: "anesthesie",
      name: "Anesthésie & Réanimation",
      doctors: ["Dr Etienne SENE", "Dr Nathalie SANCHEZ"],
      icon: <FaUserMd />,
      color: "#6c5ce7",
      gradient: "linear-gradient(135deg, #6c5ce7, #5f3dc4)",
      image: monImage040,
      features: ["Visite pré anesthésique", "Sédation", "Anesthésie"]
    },
    {
      category: "dermatologie",
      name: "Dermatologie",
      doctors: ["Dr Anta SOUMARE"],
      icon: <FaUserMd />,
      color: "#fd79a8",
      gradient: "linear-gradient(135deg, #fd79a8, #e84393)",
      image: monImage50,
      features: ["Consultation dermatologique", "Traitement des rides", "Vergétures", "Cicatrices", "Peau grasse", "Pores dilatés"]
    },
    {
      category: "rhumatologie",
      name: "Rhumatologie",
      doctors: ["Dr Cheikh Ahmadou Bamba DIAW"],
      icon: <FaUserMd />,
      color: "#00cec9",
      gradient: "linear-gradient(135deg, #00cec9, #00b894)",
      image: monImage54,
      features: ["Consultation", "Infiltrations", "Injections"]
    },
    {
      category: "cancerologie",
      name: "Cancérologie",
      doctors: ["Pr Mamadou Moustapha DIENG", "Dr Ndèye Marième DIAGNE"],
      icon: <FaUserMd />,
      color: "#d63031",
      gradient: "linear-gradient(135deg, #d63031, #c0392b)",
      image: monImage53,
      features: ["Consultation", "Chimiothérapie", "Soins palliatifs"]
    },
    {
      category: "hematologie",
      name: "Hématologie",
      doctors: ["Pr Fatou Samba NDIAYE", "Pr Seynabou FALL"],
      icon: <FaVial />,
      color: "#e17055",
      gradient: "linear-gradient(135deg, #e17055, #d63031)",
      image: monImage55,
      features: ["Anémies", "Drépanocytose", "Cancer du sang", "Chimiothérapie", "Médecine interne"]
    },
    {
      category: "urologie",
      name: "Urologie",
      doctors: ["Pr Cheikhna SYLLA", "Pr Alain Ndoye"],
      icon: <FaUserMd />,
      color: "#0984e3",
      gradient: "linear-gradient(135deg, #0984e3, #074abd)",
      image:monImage046,
      features: ["Consultation", "Échographie prostate", "Échographie appareil et voies urinaires"]
    },
    {
      category: "orthopedie",
      name: "Orthopédie",
      doctors: ["Dr Magatte NDAW"],
      icon: <FaUserMd />,
      color: "#fdcb6e",
      gradient: "linear-gradient(135deg, #fdcb6e, #f39c12)",
      image: monImage53,
      features: ["Consultation", "immobilisation plâtrée", "Infiltration / PRP (Plasma Riche en Plaquettes)"]
    },
    {
      category: "geriatrie",
      name: "Gériatrie",
      doctors: ["Dr Oumar DIOP"],
      icon: <FaUserMd />,
      color: "#636e72",
      gradient: "linear-gradient(135deg, #636e72, #2d3436)",
      image: monImage53,
      features: ["Troubles de la mémoire (Alzheimer)", "Autonomie et nutrition du sujet âgé", "Évaluation gériatrique standardisée"]
    },
    {
      category: "reeducation",
      name: "Médecine Physique & Rééducation",
      doctors: ["Dr Seydina Ousmane BA"],
      icon: <FaUserMd />,
      color: "#00b894",
      gradient: "linear-gradient(135deg, #00b894, #00a085)",
      image: monImage45,
      features: ["Rééducation fonctionnelle"]
    },
    {
      category: "osteopathie",
      name: "Ostéopathie",
      doctors: ["Sr Agnès COLY"],
      icon: <FaUserMd />,
      color: "#74b9ff",
      gradient: "linear-gradient(135deg, #74b9ff, #0984e3)",
      image: monImage43,
      features: ["Traitement des douleurs articulaires", "Ostéopathie viscérale",]
    },
    {
      category: "laboratoire",
      name: "Laboratoire d'Analyses Médicales",
      doctors: ["Équipe spécialisée"],
      icon: <FaFlask />,
      color: "#a29bfe",
      gradient: "linear-gradient(135deg, #a29bfe, #6c5ce7)",
      image: monImage26,
      features: ["Hématologie", "Biochimie", "Hormonologie", "Médecine anti-âge"]
    },
    {
      category: "echographie",
      name: "Échographie",
      doctors: ["Dr Cheikh Tidiane DIOUF"],
      icon: <FaUserMd />,
      color: "#81ecec",
      gradient: "linear-gradient(135deg, #81ecec, #00cec9)",
      image: monImage46,
      features: ["Échographie abdominale", "Échographie pelvienne", "Échographie vasculaire", "Échographie viscérale et tissus mous"]
    },
    {
      category: "psychiatrie",
      name: "Psychiatrie & Addictologie",
      doctors: ["Dr Hélène DIOUF"],
      icon: <FaBrain />,
      color: "#6c5ce7",
      gradient: "linear-gradient(135deg, #6c5ce7, #5f3dc4)",
      image: monImage48,
      features: ["Psychothérapie", "Consultation psychiatrique", "Sevrage alcool & autres substances"]
    },
    {
      category: "psychologie",
      name: "Psychologie Clinique",
      doctors: [""],
      icon: <FaBrain />,
      color: "#6c5ce7",
      gradient: "linear-gradient(135deg, #6c5ce7, #5f3dc4)",
      image:monImage43,
      features: ["Thérapie cognitive", "Évaluation psychologique","Thérapie familiale"]
    },
    {
      category: "kinesitherapie",
      name: "Kinésithérapie",
      doctors: ["Fulgence SARR", "Biram NDOYE"],
      icon: <FaUserMd />,
      color: "#55efc4",
      gradient: "linear-gradient(135deg, #55efc4, #00b894)",
      image: monImage34,
      features: ["Massage thérapeutique", "Rééducation motrice"]
    },
    {
      category: "sport",
      name: "Sport de Remise en Forme / Yoga",
      doctors: ["Coachs spécialisés"],
      icon: <FaUserMd />,
      color: "#f18b07ff",
      gradient: "linear-gradient(135deg, #ffeaa7, #fdcb6e)",
      image:monImage16,
      features: ["Fitness", "Yoga", "Zumba", "Marche sportive"]
    }
  ].sort((a, b) => {
    // Ordre personnalisé selon la demande de l'utilisateur
    const customOrder = [
      "Cardiologie",
      "Réadaptation Cardiovasculaire", 
      "Chirurgie Cardio-Vasculaire",
      "Pneumologie - Spirométrie - Fibroscopie bronchique",
      "Gastro-Entérologie & Endoscopie Digestive",
      "Anesthésie & Réanimation",
      "Gynécologie",
      "Gériatrie",
      "Pédiatrie - Endocrinologie",
      "Nutrition - Nutrithérapie",
      "Diabétologie",
      "Dermatologie",
      "Cancérologie",
      "Hématologie",
      "Urologie",
      "Psychiatrie & Addictologie",
      "Psychologie Clinique",
      "Rhumatologie",
      "Orthopédie",
      "Médecine Physique & Rééducation",
      "Kinésithérapie",
      "Ostéopathie",
      "Laboratoire d'Analyses Médicales",
      "Échographie",
      "Sport de Remise en Forme / Yoga"
    ];
    
    const indexA = customOrder.indexOf(a.name);
    const indexB = customOrder.indexOf(b.name);
    
    return indexA - indexB;
  });

  // Spécialités mises en avant pour la section hero - utiliser tous les services médicaux
  const featuredSpecialties = medicalServices.map(service => ({
    name: service.name,
    icon: service.icon,
    description: service.doctors.join(", "),
    color: service.color,
    stats: `${service.doctors.length} médecin${service.doctors.length > 1 ? 's' : ''}`
  }));

  const backgroundImages = [
    monImage14,
    monImage14,
    monImage6,
    monImage7,
    monImage8,
    monImage9,
  ];

  const carouselImages = [
    { src: monImage14 },    // ac.jpg
    { src: monImage40 },    // cardiologie.jpg
    { src: monImage41 },    // se1.jpg
    { src: monImage42 },    // se2.jpg
    { src: monImage45 },    // sgem1.jpg
    { src: monImage046 },   // sgem3.jpg
    { src: monImage040 },   // ac32.jpeg
    { src: monImage47 },    // spd1.jpg
    { src: monImage48 },    // spd2.jpg
    { src: monImage51 },    // spp1.jpg
    { src: monImage52 },    // spp2.jpg
    { src: monImage16 },    // ac3.jpeg
    { src: monImage17 },    // ac4.jpeg
    { src: monImage22 },    // ac9.jpeg
    { src: monImage25 },    // ac12.jpeg
    { src: monImage26 },    // ac13.jpeg
    { src: monImage27 },    // ac14.jpeg
    { src: monImage28 },    // ac15.jpeg
    { src: monImage30 },    // ac17.jpeg
    { src: monImage31 },    // ac18.jpeg
    { src: monImage32 },    // ac19.jpeg
    { src: monImage34 },    // ac21.jpeg
    { src: monImage37 }     // ac24.jpeg
  ];

  const devTeam = [
    {
      name: "SAMD",
      role: "Transformer l'expérience des soins de santé grâce au numérique",
      image: monImage1,
      description: "Tel: +770977918 / Email : samdigitale2024@gmail.com",
      url: "https://www.samdigitale.com/",
    },
    {
      name: "SAMD",
      role: "Optimiser l'accessibilité aux soins médicaux grâce au numérique",
      image: monImage2,
      description: "Tel: +770977918 / Email : samdigitale2024@gmail.com",
      url: "https://www.samdigitale.com/",
    },
    {
      name: "SAMD",
      role: "Donner du sourire aux FAMILLES grâce au numérique",
      image: monImage3,
      description: "Tel: +770977918 / Email : samdigitale2024@gmail.com",
      url: "https://www.samdigitale.com/",
    },
  ];

  // Auto-rotation des spécialités dans le hero
  useEffect(() => {
    if (!isSpecialtyAutoPlay) return;
    
    const interval = setInterval(() => {
      setActiveSpecialtyIndex((prev) => 
        prev === featuredSpecialties.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [isSpecialtyAutoPlay, featuredSpecialties.length]);

  // Autres useEffects existants...
  useEffect(() => {
    emailjs.init("MCVx8ryDmfsqT_R_P");
  }, []);

  useEffect(() => {
    const unsubscribe = loadComments();
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const imageCarouselInterval = setInterval(() => {
      setActiveImageCarousel((prev) =>
        prev === carouselImages.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => {
      clearInterval(imageCarouselInterval);
    };
  }, []);

  useEffect(() => {
    setIsLoaded(true);

    const devTeamInterval = setInterval(() => {
      setActiveDevTeamMember((prev) =>
        prev === devTeam.length - 1 ? 0 : prev + 1
      );
    }, 4000);

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 6000);

    const handleScroll = () => {
      setScrollPosition(window.scrollY);

      const scrollPos = window.scrollY + 100;

      if (
        heroRef.current &&
        scrollPos < heroRef.current.offsetTop + heroRef.current.offsetHeight
      ) {
        setActiveSection("hero");
      } else if (
        servicesRef.current &&
        scrollPos <
          servicesRef.current.offsetTop + servicesRef.current.offsetHeight
      ) {
        setActiveSection("services");
      } else if (
        aboutRef.current &&
        scrollPos < aboutRef.current.offsetTop + aboutRef.current.offsetHeight
      ) {
        setActiveSection("about");
      } else if (contactRef.current) {
        setActiveSection("contact");
      }
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      clearInterval(devTeamInterval);
      clearInterval(interval);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Fonctions existantes...
  const [formStatus, setFormStatus] = useState({
    submitting: false,
    submitted: false,
    info: { error: false, msg: null },
  });

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setFormStatus({
      submitting: true,
      submitted: false,
      info: { error: false, msg: "Envoi en cours..." },
    });

    const serviceId = "service_tgx6ffp";
    const templateId = "template_fjjoc53";
    const publicKey = "MCVx8ryDmfsqT_R_P";

    emailjs
      .sendForm(serviceId, templateId, form.current, publicKey)
      .then((result) => {
        console.log("Email envoyé avec succès!", result.text);
        form.current.reset();
        setFormStatus({
          submitting: false,
          submitted: true,
          info: { error: false, msg: "Message envoyé avec succès!" },
        });

        setTimeout(() => {
          setFormStatus({
            submitting: false,
            submitted: false,
            info: { error: false, msg: null },
          });
        }, 3000);
      })
      .catch((error) => {
        console.error("Erreur lors de l'envoi de l'email:", error.text);
        setFormStatus({
          submitting: false,
          submitted: false,
          info: {
            error: true,
            msg: "Une erreur est survenue lors de l'envoi du message.",
          },
        });
      });
  };

  const moderateComment = (text) => {
    const inappropriateWords = ['con', 'connasse'];
    const lowerText = text.toLowerCase();
    
    const hasInappropriateWords = inappropriateWords.some(word => {
      const wordRegex = new RegExp(`\\b${word}\\b`, 'i');
      return wordRegex.test(lowerText);
    });
    
    const isValidLength = text.trim().length >= 10 && text.trim().length <= 1000;
    const isNotSpam = !/^(.)\1{9,}$/.test(text.trim());
    const uppercaseRatio = (text.match(/[A-Z]/g) || []).length / text.length;
    const isNotShouting = uppercaseRatio < 0.7;
    
    return {
      approved: !hasInappropriateWords && isValidLength && isNotSpam && isNotShouting,
      reason: hasInappropriateWords ? 'Contenu inapproprié détecté' :
              !isValidLength ? 'Longueur du texte non valide' :
              !isNotSpam ? 'Contenu détecté comme spam' :
              !isNotShouting ? 'Trop de majuscules détectées' : ''
    };
  };

  const loadComments = () => {
    const q = query(collection(db, "comments"), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const commentsData = [];
      querySnapshot.forEach((doc) => {
        commentsData.push({ id: doc.id, ...doc.data() });
      });
      setComments(commentsData);
    });
    
    return unsubscribe;
  };

  const handleCommentChange = (field, value) => {
    setNewComment(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    
    if (!newComment.name.trim() || !newComment.message.trim()) {
      setCommentMessage({ text: 'Veuillez remplir tous les champs obligatoires', type: 'error' });
      return;
    }

    if (newComment.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newComment.email.trim())) {
      setCommentMessage({ text: 'Veuillez entrer une adresse email valide', type: 'error' });
      return;
    }

    setCommentSubmitting(true);
    
    try {
      const moderationResult = moderateComment(newComment.message);
      
      if (!moderationResult.approved) {
        setCommentMessage({ 
          text: `Commentaire refusé: ${moderationResult.reason}. Veuillez modifier votre message.`, 
          type: 'error' 
        });
        setCommentSubmitting(false);
        return;
      }

      await addDoc(collection(db, "comments"), {
        name: newComment.name.trim(),
        email: newComment.email.trim() || '',
        message: newComment.message.trim(),
        rating: newComment.rating,
        createdAt: serverTimestamp(),
        approved: true,
        moderatedAt: serverTimestamp(),
        moderationType: 'automatic'
      });

      setNewComment({
        name: '',
        email: '',
        message: '',
        rating: 5
      });
      
      setCommentMessage({ text: 'Commentaire publié avec succès!', type: 'success' });
      
      setTimeout(() => {
        setCommentMessage({ text: '', type: '' });
      }, 5000);
      
    } catch (error) {
      console.error("Erreur lors de l'ajout du commentaire:", error);
      setCommentMessage({ text: 'Erreur lors de l\'envoi du commentaire. Veuillez réessayer.', type: 'error' });
    } finally {
      setCommentSubmitting(false);
    }
  };

  const renderStars = (rating, interactive = false, onRatingChange = null) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <FaStar
          key={i}
          className={`star ${i <= rating ? 'filled' : ''} ${interactive ? 'interactive' : ''}`}
          onClick={interactive ? () => onRatingChange(i) : undefined}
          style={{ 
            color: i <= rating ? '#ffc107' : '#e4e5e9',
            cursor: interactive ? 'pointer' : 'default'
          }}
        />
      );
    }
    return stars;
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const swipeDistance = touchStartX.current - touchEndX.current;
    const minSwipeDistance = 50;

    if (swipeDistance > minSwipeDistance) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    } else if (swipeDistance < -minSwipeDistance) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? backgroundImages.length - 1 : prevIndex - 1
      );
    }
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const yOffset = -80;
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    if (isMobile) {
      setShowMenu(false);
    }
  };

  const nextImage = () => {
    setActiveImageCarousel((prev) =>
      prev === carouselImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setActiveImageCarousel((prev) =>
      prev === 0 ? carouselImages.length - 1 : prev - 1
    );
  };

  const navigateImageCarousel = (index) => {
    setActiveImageCarousel(index);
  };

  return (
    <div className="home-page">
      {/* Header moderne avec effet de transparence */}
      <header className={`site-header ${scrollPosition > 30 ? "scrolled" : ""}`}>
        <div className="container">
          <div className="header-inner">
            <div className="logo">
              <div className="logo-icon" onClick={() => navigate("/auth")}>
                <img src={monImage13} alt="Logo PMGS" className="logo-image" />
              </div>
              <div className="logo-text">
                <span className="logo-name">PLATEAU MÉDICAL</span>
                <img src={logoplateau01} alt="Pr Gabriel A. Senghor" style={{ height: '2.5em', verticalAlign: 'middle' }} />

              </div>
            </div>

            {!isMobile && (
              <nav className="main-nav">
                <ul>
                  <li className={activeSection === "hero" ? "active" : ""}>
                    <a onClick={() => scrollToSection("hero")}>Accueil</a>
                  </li>
                  <li className={activeSection === "services" ? "active" : ""}>
                    <a onClick={() => scrollToSection("services")}>Services</a>
                  </li>
                  <li className={activeSection === "about" ? "active" : ""}>
                    <a onClick={() => scrollToSection("about")}>À propos</a>
                  </li>
                  <li className={activeSection === "contact" ? "active" : ""}>
                    <a onClick={() => scrollToSection("contact")}>Contact</a>
                  </li>
                </ul>
              </nav>
            )}

            {isMobile && (
              <button
                className="menu-toggle"
                onClick={() => setShowMenu(true)}
              >
                <FaBars />
              </button>
            )}
          </div>
        </div>
      </header>

      {/* Section Hero révolutionnaire avec spécialités intégrées */}
      <section id="hero" ref={heroRef} className="hero-section">
        <div
          className="hero-slider"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {backgroundImages.map((image, index) => (
            <div
              key={index}
              className={`hero-slide ${currentImageIndex === index ? "active" : ""}`}
              style={{ backgroundImage: `url(${image})` }}
            >
              <div className="hero-overlay"></div>
            </div>
          ))}

          <div className="container">
            <div className="hero-content">
              {/* Contenu principal du hero */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                className="hero-main-content"
              >
                <div className="hero-text">
                  <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                  >
                    <span className="text-white fw-bolder">PLATEAU MÉDICAL</span>
                    <br />
                    <span className="text-primary fw-bolder hero-subtitle">
                      <img src={logoplateau01} alt="Pr Gabriel A. Senghor" style={{ height: '2.5em', verticalAlign: 'middle', filter: 'brightness(0) invert(1)' }} />

                    </span>
                  </motion.h1>

                  <motion.p
                    className="hero-tagline"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                  >
                    <span>Santé</span> • <span>Nutrition</span> • <span>Bien-être</span>
                    <br />
                    Fann résidence juste derrière Auchan
                  </motion.p>

                  <motion.div
                    className="hero-actions"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.6 }}
                  >
                    {/* 
                    <Button
                      className="btn-primary hero-btn"
                      onClick={() => navigate("/Quick")}
                    >
                      <FaCalendarCheck />
                      Prendre Rendez-vous
                      <FaArrowRight />
                    </Button>
                    */}
                    <Button
                      className="btn-outline hero-btn"
                      onClick={() => scrollToSection("services")}
                    >
                      <FaStethoscope />
                      Découvrir nos services
                      <FaArrowRight />
                    </Button>
                  </motion.div>
                </div>

                {/* Section spécialités intégrée dans le hero */}
                <motion.div
                  className="hero-specialties-showcase"
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.8 }}
                >
                  <div className="specialties-header">
                    <h3>Nos Spécialités Médicales</h3>
                    <p>Excellence et expertise dans chaque domaine</p>
                  </div>

                  <div className="specialties-carousel">
                    <div className="specialty-display">
                      <AnimatePresence mode="wait">
                        <motion.div
                          key={activeSpecialtyIndex}
                          className="active-specialty"
                          initial={{ opacity: 0, scale: 0.8, rotateY: 90 }}
                          animate={{ opacity: 1, scale: 1, rotateY: 0 }}
                          exit={{ opacity: 0, scale: 0.8, rotateY: -90 }}
                          transition={{ duration: 0.6 }}
                        >
                          <div 
                            className="specialty-card-hero"
                            style={{ 
                              background: `linear-gradient(135deg, ${featuredSpecialties[activeSpecialtyIndex].color}15, ${featuredSpecialties[activeSpecialtyIndex].color}05)`,
                              borderLeft: `4px solid ${featuredSpecialties[activeSpecialtyIndex].color}`
                            }}
                          >
                            <div className="specialty-icon-hero" style={{ color: featuredSpecialties[activeSpecialtyIndex].color }}>
                              {featuredSpecialties[activeSpecialtyIndex].icon}
                            </div>
                            <div className="specialty-content-hero">
                              <h4>{featuredSpecialties[activeSpecialtyIndex].name}</h4>
                              <p>{featuredSpecialties[activeSpecialtyIndex].description}</p>
                              <div className="specialty-stats" style={{ color: featuredSpecialties[activeSpecialtyIndex].color }}>
                                <FaAward />
                                <span>{featuredSpecialties[activeSpecialtyIndex].stats}</span>
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      </AnimatePresence>
                    </div>

                    <div className="specialties-grid-mini">
                      {featuredSpecialties.map((specialty, index) => (
                        <motion.div
                          key={index}
                          className={`mini-specialty-card ${index === activeSpecialtyIndex ? 'active' : ''}`}
                          onClick={() => {
                            setActiveSpecialtyIndex(index);
                            setIsSpecialtyAutoPlay(false);
                            setTimeout(() => setIsSpecialtyAutoPlay(true), 10000);
                          }}
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          style={{ borderColor: specialty.color }}
                        >
                          <div className="mini-icon" style={{ color: specialty.color }}>
                            {specialty.icon}
                          </div>
                          <span>{specialty.name}</span>
                        </motion.div>
                      ))}
                    </div>

                    <div className="specialty-controls">
                      <button
                        className="control-btn"
                        onClick={() => setIsSpecialtyAutoPlay(!isSpecialtyAutoPlay)}
                      >
                        {isSpecialtyAutoPlay ? <FaPause /> : <FaPlay />}
                      </button>
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Indicateurs du slider */}
        <div className="hero-slider-controls">
          <div className="slider-dots">
            {backgroundImages.map((_, index) => (
              <button
                key={index}
                className={`slider-dot ${currentImageIndex === index ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Section Informations Pratiques */}
      <section className="info-section-modern">
        <div className="container">
          <motion.div
            className="info-cards-grid-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <motion.div
              className="info-card-modern schedule"
              whileHover={{ scale: 1.02, y: -5 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <div className="card-header">
                <div className="icon-wrapper">
                  <FaClock />
                </div>
                <h4>Horaires</h4>
              </div>
              <div className="card-content">
                <div className="schedule-row">
                  <span>Lun - Ven</span>
                  <span className="time">08H00 — 18H30</span>
                </div>
                <div className="schedule-row">
                  <span>Sam - Dim</span>
                  <span className="time closed">Fermé</span>
                </div>
              </div>
            </motion.div>

            <motion.div
              className="info-card-modern contact"
              whileHover={{ scale: 1.02, y: -5 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="card-header">
                <div className="icon-wrapper">
                  <FaPhone />
                </div>
                <h4>Contact</h4>
              </div>
              <div className="card-content">
                <div className="contact-number">
                  <FaPhone />
                  <span>+221 338248888</span>
                </div>
                <div className="contact-number">
                  <FaWhatsapp />
                  <span>+221 772776535</span>
                </div>
              </div>
            </motion.div>

            <motion.div
              className="info-card-modern wellness"
              whileHover={{ scale: 1.02, y: -5 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <div className="card-header">
                <div className="icon-wrapper">
                  <FaHandHoldingHeart />
                </div>
                <h4>Bien-être</h4>
              </div>
              <div className="card-content">
                <div className="wellness-item">
                  <span>FITNESS</span>
                  <small>Lun-Mer-Ven 17:30-18:30 & 18:30-19:30</small>
                </div>
                <div className="wellness-item">
                  <span>ZUMBA</span>
                  <small>Mardi 18:00</small>
                </div>
                <div className="wellness-item">
                  <span>MARCHE</span>
                  <small>Jeudi 18:00</small>
                </div>
                <div className="wellness-item">
                  <span>YOGA</span>
                  <small>Samedi 11:00</small>
                </div>
              </div>
            </motion.div>

            <motion.div
              className="info-card-modern snack-healthy"
              whileHover={{ scale: 1.02, y: -5 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <div className="card-header">
                <div className="icon-wrapper">
                  <FaAppleAlt />
                </div>
                <h4>Snack Healthy</h4>
              </div>
              <div className="card-content">
                <div className="snack-image-container" onClick={handleOpenImageModal} style={{ cursor: 'pointer' }}>
                  <img src={monImage12} alt="Snack Healthy" className="snack-image" />
                  <div className="zoom-overlay">
                    <FaSearch />
                  </div>
                </div>
                <div className="snack-info">
                  <div className="snack-item">
                    <span>Collations saines</span>
                    <small>Fruits frais & Bio</small>
                  </div>
                  <div className="snack-item">
                    <span>Boissons naturelles</span>
                    <small>Jus frais & Tisanes</small>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Section des services avec design révolutionnaire */}
      <section id="services" ref={servicesRef} className="services-section-modern">
        <div className="container">
          <motion.div
            className="section-header-modern"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="section-badge-modern">Excellence Médicale</span>
            <h2>Nos Services Spécialisés</h2>
            <p>Une gamme complète de soins médicaux avec une approche personnalisée</p>
          </motion.div>

          <div className="services-showcase">
            <div className="services-grid-modern">
              {(showAllServices ? medicalServices : medicalServices.slice(0, 2)).map((service, index) => (
                <motion.div
                  key={index}
                  className="service-card-modern"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ 
                    y: -10, 
                    boxShadow: `0 20px 40px ${service.color}30`,
                    scale: 1.02
                  }}
                >
                  <div 
                    className="service-card-background"
                    style={{ background: service.gradient }}
                  ></div>
                  
                  <div className="service-card-content">
                    <div className="service-header-modern">
                      <motion.div
                        className="service-icon-modern"
                        style={{ 
                          background: `${service.color}20`,
                          color: service.color,
                          boxShadow: `0 10px 30px ${service.color}40`
                        }}
                        whileHover={{ 
                          rotate: 360,
                          background: service.color,
                          color: '#ffffff',
                          scale: 1.1
                        }}
                        transition={{ duration: 0.6 }}
                      >
                        {service.icon}
                      </motion.div>
                      
                      <div className="service-title-section">
                        <h3 style={{ color: service.color }}>{service.name}</h3>
                        <p className="service-description">{service.doctors.join(", ")}</p>
                      </div>
                    </div>

                    {service.features && (
                      <div className="service-features">
                        <div className="features-image-container">
                          <div className="features-image-wrapper">
                            <img
                              src={service.image || `https://via.placeholder.com/60x60/${service.color.replace('#', '')}/ffffff?text=${service.name.charAt(0)}`}
                              alt={`Prestations ${service.name}`}
                            />
                            <div className="features-overlay">
                              <h4>Prestations incluses :</h4>
                              <div className="features-overlay-list">
                                {service.features.slice(0, 4).map((feature, idx) => (
                                  <div key={idx} className="overlay-feature-item">
                                    <FaCheck style={{ color: service.color }} />
                                    <span>{feature}</span>
                                  </div>
                                ))}
                                {service.features.length > 4 && (
                                  <div className="overlay-more-features">
                                    <span>+{service.features.length - 4} autres</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/*
                    <motion.div
                      className="service-action"
                      whileHover={{ x: 5 }}
                    >
                      <button
                        className="service-btn"
                        style={{
                          background: `linear-gradient(135deg, ${service.color}, ${service.color}dd)`,
                          boxShadow: `0 5px 15px ${service.color}40`
                        }}
                        onClick={() => navigate("/Quick")}
                      >
                        <span>Prendre RDV</span>
                        <FaArrowRight />
                      </button>
                    </motion.div>
                    */}
                  </div>
                </motion.div>
              ))}
            </div>
            
            {/* Boutons de contrôle d'affichage des services */}
            <motion.div
              className="services-toggle-section"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              {!showAllServices ? (
                <motion.button
                  className="services-toggle-btn show-more"
                  onClick={() => setShowAllServices(true)}
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span>Voir plus de services</span>
                  <FaChevronDown />
                </motion.button>
              ) : (
                <motion.button
                  className="services-toggle-btn show-less"
                  onClick={() => setShowAllServices(false)}
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span>Voir moins</span>
                  <FaChevronUp />
                </motion.button>
              )}
              
              <div className="services-counter">
                <span>
                  Affichage de {showAllServices ? medicalServices.length : 2} 
                  sur {medicalServices.length} services
                </span>
              </div>
            </motion.div>
          </div>

          
        </div>
      </section>

      {/* Section Carrousel d'images modernisée */}
      <section className="image-carousel-section-modern">
        <div className="container">
          <motion.div
            className="section-header-modern"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="section-badge-modern">Notre Établissement</span>
            <h2>Découvrez notre plateau médical</h2>
            <p>Un environnement moderne et accueillant pour votre bien-être</p>
          </motion.div>

          <div className="image-carousel-container-modern">
            <div className="image-carousel-wrapper-modern">
              {carouselImages.map((image, index) => (
                <motion.div
                  key={index}
                  className={`image-carousel-slide-modern ${
                    activeImageCarousel === index ? "active" : ""
                  }`}
                  initial={{ opacity: 0 }}
                  animate={{
                    opacity: activeImageCarousel === index ? 1 : 0,
                    scale: activeImageCarousel === index ? 1 : 0.95,
                  }}
                  transition={{ duration: 0.8 }}
                >
                  <div className="image-carousel-image-modern">
                    <img src={image.src} alt="Centre médical" />
                    <div className="image-carousel-overlay-modern">
                      <div className="overlay-content-modern">
                        <motion.div
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: 0.3 }}
                        >
                          <h3>Excellence Médicale</h3>
                          <p>Un environnement de soins moderne et chaleureux</p>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Contrôles modernisés */}
            <div className="image-carousel-controls-modern">
              <button
                className="carousel-arrow-modern prev"
                onClick={prevImage}
              >
                <FaChevronLeft />
              </button>
              <button
                className="carousel-arrow-modern next"
                onClick={nextImage}
              >
                <FaChevronRight />
              </button>
            </div>

            {/* Indicateurs modernisés */}
            <div className="image-carousel-indicators-modern">
              {carouselImages.map((_, index) => (
                <button
                  key={index}
                  className={`carousel-indicator-modern ${
                    activeImageCarousel === index ? "active" : ""
                  }`}
                  onClick={() => navigateImageCarousel(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Section À propos modernisée */}
      <section id="about" ref={aboutRef} className="about-section-modern">
        <div className="container">
          <motion.div
            className="section-header-modern"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="section-badge-modern">À Propos</span>
            <h2>Une histoire d'excellence et d'engagement</h2>
            <p>Un centre médical de référence au Sénégal</p>
          </motion.div>

          <div className="about-content-modern">
            <motion.div
              className="about-image-modern"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <img
                src="https://lh3.googleusercontent.com/p/AF1QipOcIfekPWiYH-RBNllUhybad8WaYAbG0zWtOc8j=s680-w680-h510"
                alt="Plateau médical Pr Gabriel A. Senghor"
              />
              <div className="image-overlay-about">
                <div className="stats-overlay">
                  <div className="stat-item">
                    <span className="stat-number">21+</span>
                    <span className="stat-label">Années d'expérience</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">25+</span>
                    <span className="stat-label">Spécialités médicales</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">5000+</span>
                    <span className="stat-label">Patients satisfaits</span>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div
              className="about-text-modern"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h3>Notre Mission</h3>
              <p>
                Plateau Médical Pr Gabriel A. Senghor s'engage à offrir des
                soins médicaux de la plus haute qualité à ses patients. Avec une
                équipe pluridisciplinaire de spécialistes couvrant de nombreux
                domaines médicaux, nous mettons tout en œuvre pour garantir
                votre bien-être et optimiser votre santé.
              </p>
              <p>
                Notre centre propose une approche holistique de la santé, alliant
                médecine moderne, techniques de rééducation avancées et
                accompagnement personnalisé pour chaque patient.
              </p>

              <div className="values-grid">
                <div className="value-item">
                  <FaAward />
                  <div>
                    <h4>Excellence</h4>
                    <p>Standards de qualité les plus élevés</p>
                  </div>
                </div>
                <div className="value-item">
                  <FaHandHoldingHeart />
                  <div>
                    <h4>Bienveillance</h4>
                    <p>Écoute et accompagnement personnalisé</p>
                  </div>
                </div>
                <div className="value-item">
                  <FaRocket />
                  <div>
                    <h4>Innovation</h4>
                    <p>Technologies médicales de pointe</p>
                  </div>
                </div>
                <div className="value-item">
                  <FaGraduationCap />
                  <div>
                    <h4>Expertise</h4>
                    <p>Équipe médicale hautement qualifiée</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section Contact modernisée */}
      <section id="contact" ref={contactRef} className="contact-section-modern">
        <div className="container">
          <motion.div
            className="section-header-modern"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="section-badge-modern">Contact</span>
            <h2>Contactez-nous</h2>
            <p>Nous sommes à votre disposition pour répondre à vos questions</p>
          </motion.div>

          <div className="contact-content-modern">
            <div className="contact-info-grid">
              <motion.div
                className="contact-card-modern"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
                whileHover={{ y: -5, scale: 1.02 }}
              >
                <div className="contact-icon-modern">
                  <FaMapMarkerAlt />
                </div>
                <h4>Adresse</h4>
                <p>
                  Fann résidence juste derrière Auchan et le Centre d'Appel
                  "Foundever", Dakar, Sénégal
                </p>
              </motion.div>

              <motion.div
                className="contact-card-modern"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                whileHover={{ y: -5, scale: 1.02 }}
              >
                <div className="contact-icon-modern">
                  <FaPhone />
                </div>
                <h4>Téléphone</h4>
                <div className="phone-numbers">
                  <a href="tel:+221338248888">+221 338248888</a>
                  <a href="tel:+221772776535">+221 772776535</a>
                </div>
              </motion.div>

              <motion.div
                className="contact-card-modern"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
                whileHover={{ y: -5, scale: 1.02 }}
              >
                <div className="contact-icon-modern">
                  <FaEnvelope />
                </div>
                <h4>Email</h4>
                <a href="mailto:plateaumedicalgabrielsenghor@gmail.com">
                  plateaumedicalgabrielsenghor@gmail.com
                </a>
              </motion.div>

              <motion.div
                className="contact-card-modern"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                whileHover={{ y: -5, scale: 1.02 }}
              >
                <div className="contact-icon-modern">
                  <FaClock />
                </div>
                <h4>Horaires</h4>
                <div className="schedule-info">
                  <p><strong>Lun - Ven:</strong> 08H00 — 18H30</p>
                  <p><strong>Sam - Dim:</strong> Fermé</p>
                </div>
              </motion.div>
            </div>

            {/* Section Urgences supprimée */}
          </div>
        </div>
      </section>

      {/* Section Commentaires modernisée */}
      <section className="comments-section-modern">
        <div className="container">
          <motion.div
            className="section-header-modern"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="section-badge-modern">Témoignages</span>
            <h2>L'avis de nos patients</h2>
            <p>Découvrez les expériences de ceux qui nous font confiance</p>
          </motion.div>

          <div className="comments-wrapper-modern">
            {/* Formulaire d'ajout de commentaire */}
            <motion.div
              className="comment-form-section-modern"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h3>Partagez votre expérience</h3>
              <form className="comment-form-modern" onSubmit={handleCommentSubmit}>
                <div className="form-row-modern">
                  <div className="form-group-modern">
                    <label htmlFor="comment-name">Nom complet *</label>
                    <input
                      type="text"
                      id="comment-name"
                      value={newComment.name}
                      onChange={(e) => handleCommentChange('name', e.target.value)}
                      placeholder="Votre nom"
                      required
                    />
                  </div>
                  <div className="form-group-modern">
                    <label htmlFor="comment-email">Email (optionnel)</label>
                    <input
                      type="email"
                      id="comment-email"
                      value={newComment.email}
                      onChange={(e) => handleCommentChange('email', e.target.value)}
                      placeholder="Votre email"
                    />
                  </div>
                </div>

                <div className="form-group-modern">
                  <label>Évaluation *</label>
                  <div className="rating-input-modern">
                    {renderStars(newComment.rating, true, (rating) => handleCommentChange('rating', rating))}
                    <span className="rating-text">({newComment.rating}/5)</span>
                  </div>
                </div>

                <div className="form-group-modern">
                  <label htmlFor="comment-message">Votre commentaire *</label>
                  <textarea
                    id="comment-message"
                    value={newComment.message}
                    onChange={(e) => handleCommentChange('message', e.target.value)}
                    placeholder="Partagez votre expérience avec nous..."
                    rows="4"
                    maxLength="1000"
                    required
                  ></textarea>
                  <div className="char-counter-modern">
                    {newComment.message.length}/1000 caractères
                  </div>
                </div>

                <Button
                  type="submit"
                  className="btn-submit-modern"
                  disabled={commentSubmitting}
                >
                  {commentSubmitting ? (
                    <>
                      <div className="spinner"></div>
                      Envoi en cours...
                    </>
                  ) : (
                    <>
                      <FaCheck />
                      Publier le commentaire
                    </>
                  )}
                </Button>

                {commentMessage.text && (
                  <div className={`comment-message-modern ${commentMessage.type}`}>
                    {commentMessage.text}
                  </div>
                )}
              </form>
            </motion.div>

            {/* Liste des commentaires */}
            <motion.div
              className="comments-list-modern"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="comments-header-modern">
                <h3>Derniers témoignages</h3>
                <div className="comments-stats-modern">
                  <div className="stat-item-modern">
                    <span className="stat-number">{comments.filter(comment => comment.approved).length}</span>
                    <span className="stat-label">Avis</span>
                  </div>
                  <div className="stat-item-modern">
                    <span className="stat-number">
                      {comments.filter(comment => comment.approved).length > 0 
                        ? (comments.filter(comment => comment.approved).reduce((sum, comment) => sum + comment.rating
, 0) / comments.filter(comment => comment.approved).length).toFixed(1)
                        : '0.0'
                      }
                    </span>
                    <span className="stat-label">Note moyenne</span>
                  </div>
                </div>
              </div>
              
              {comments.filter(comment => comment.approved).length === 0 ? (
                <div className="no-comments-modern">
                  <div className="no-comments-icon">
                    <FaQuoteLeft />
                  </div>
                  <h4>Aucun témoignage pour le moment</h4>
                  <p>Soyez le premier à partager votre expérience avec nous !</p>
                </div>
              ) : (
                <div className="comments-grid-modern">
                  {comments
                    .filter(comment => comment.approved)
                    .slice(0, 3)
                    .map((comment) => (
                      <motion.div
                        key={comment.id}
                        className="comment-card-modern"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        whileHover={{ y: -5, scale: 1.02 }}
                      >
                        <div className="comment-header-modern">
                          <div className="comment-author-modern">
                            <div className="author-avatar-modern">
                              {comment.name.charAt(0).toUpperCase()}
                            </div>
                            <div className="author-info-modern">
                              <h4>{comment.name}</h4>
                              <div className="comment-rating-modern">
                                {renderStars(comment.rating)}
                              </div>
                            </div>
                          </div>
                          <div className="comment-date-modern">
                            {comment.createdAt?.toDate ? 
                              comment.createdAt.toDate().toLocaleDateString('fr-FR') : 
                              'Récemment'
                            }
                          </div>
                        </div>
                        <div className="comment-content-modern">
                          <FaQuoteLeft className="quote-icon" />
                          <p>{comment.message}</p>
                          <FaQuoteRight className="quote-icon-end" />
                        </div>
                      </motion.div>
                    ))}
                </div>
              )}
              
              {comments.filter(comment => comment.approved).length > 3 && (
                <div className="more-comments-info-modern">
                  <p>
                    <FaEye />
                    Affichage des 3 derniers avis sur {comments.filter(comment => comment.approved).length} au total
                  </p>
                </div>
              )}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section Carte modernisée */}
      <section className="map-section-modern">
        <div className="container">
          <motion.div
            className="section-header-modern"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>Géolocalisation</h2>
            <div className="map-header-content">
              <p>Situé au cœur de Dakar, facilement accessible</p>
              <div className="map-info-inline">
                <div className="map-info-card">
                  <h4>PLATEAU MÉDICAL Pr GABRIEL A SENGHOR</h4>
                  <p>Fann résidence, derrière Auchan, Dakar</p>
                  
                  <div className="map-actions">
                    <motion.button
                      className="directions-btn"
                      onClick={() => window.open('https://www.google.com/maps/dir//PLATEAU+MEDICAL+Pr+GABRIEL+A+SENGHOR+Fann+résidence+Dakar+Sénégal/@14.7077,-17.4438,15z', '_blank')}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <FaMapMarkerAlt />
                      <span>Itinéraire</span>
                    </motion.button>
                    <motion.button
                      className="view-larger-btn"
                      onClick={() => window.open('https://www.google.com/maps/search/PLATEAU+MEDICAL+Pr+GABRIEL+A+SENGHOR+Fann+résidence+Dakar+Sénégal', '_blank')}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <FaExternalLinkAlt />
                      <span>Voir sur Google Maps</span>
                    </motion.button>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      
        <motion.div
          className="map-container-modern"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3859.0517242430934!2d-17.4438!3d14.7077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTTCsDQyJzI3LjciTiAxN8KwMjYnMzcuNyJX!5e0!3m2!1sfr!2s!4v1615554887163!5m2!1sfr!2s&q=PLATEAU+MEDICAL+Pr+GABRIEL+A+SENGHOR+Dakar"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Carte du PLATEAU MÉDICAL Pr GABRIEL A SENGHOR"
          ></iframe>
        </motion.div>
      </section>

      {/* Footer modernisé */}
      <footer className="site-footer-modern">
        <div className="container">
          <div className="footer-content-modern">
            <div className="footer-main">
              <div className="footer-about-modern">
                <div className="footer-logo-modern">
                  <img src={monImage13} alt="Logo PMGS" />
                  
                </div>
                <p className="footer-description">
                  Centre médical de référence au Sénégal, offrant des soins de qualité 
                  avec une approche humaine et des technologies de pointe.
                </p>
                <div className="footer-specialties">
                  <span>Santé</span>
                  <span>Nutrition</span>
                  <span>Bien-être</span>
                </div>
              </div>

              <div className="footer-links-modern">
                <h4>Navigation</h4>
                <ul>
                  <li><a onClick={() => scrollToSection("hero")}>Accueil</a></li>
                  <li><a onClick={() => scrollToSection("services")}>Services</a></li>
                  <li><a onClick={() => scrollToSection("about")}>À propos</a></li>
                  <li><a onClick={() => scrollToSection("contact")}>Contact</a></li>
                </ul>
              </div>

              <div className="footer-services-modern">
                <h4>Nos Spécialités</h4>
                <ul>
                  <li>Cardiologie</li>
                  <li>Pédiatrie</li>
                  <li>Diabétologie</li>
                  <li>Gynécologie</li>
                  <li>Pneumologie</li>
                  <li>Et bien plus...</li>
                </ul>
              </div>

              <div className="footer-contact-modern">
                <h4>Contact</h4>
                <div className="footer-contact-item">
                  <FaMapMarkerAlt />
                  <span>Fann résidence, Dakar</span>
                </div>
                <div className="footer-contact-item">
                  <FaPhone />
                  <span>+221 338248888</span>
                </div>
                <div className="footer-contact-item">
                  <FaEnvelope />
                  <span>plateaumedicalgabrielsenghor@gmail.com</span>
                </div>
                <div className="footer-contact-item">
                  <FaClock />
                  <span>Lun-Ven: 08H00-18H30</span>
                </div>
              </div>
            </div>

            <div className="footer-bottom-modern">
              <div className="footer-copyright">
                <p>&copy; {new Date().getFullYear()} PLATEAU MÉDICAL Pr GABRIEL A. SENGHOR. Tous droits réservés.</p>
              </div>
              <div className="footer-credits-modern">
                <span>Développé avec ❤️ par </span>
                <a href="https://www.samdigitale.com" target="_blank" rel="noopener noreferrer">
                  Sen Assistance Médicale Digitale
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Boutons flottants modernisés */}
      {/* 
      <div className="floating-buttons-modern">
        <motion.div
          className="floating-appointment-modern"
          onClick={() => navigate("/Quick")}
          whileHover={{ scale: 1.1, y: -5 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaCalendarCheck />
          <span>Rendez-vous</span>
        </motion.div>

        <motion.div
          className="floating-login-modern"
          onClick={() => navigate("/auth")}
          whileHover={{ scale: 1.1, y: -5 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaUser />
          <span>Connexion</span>
        </motion.div>
      </div>
      */}

      {/* Menu mobile */}
      <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <nav className="mobile-nav-modern">
            <ul>
              <li><a onClick={() => scrollToSection("hero")}>Accueil</a></li>
              <li><a onClick={() => scrollToSection("services")}>Services</a></li>
              <li><a onClick={() => scrollToSection("about")}>À propos</a></li>
              <li><a onClick={() => scrollToSection("contact")}>Contact</a></li>
            </ul>
          </nav>
          <div className="mobile-actions-modern">
            <Button 
              className="btn-primary-modern mobile-btn"
              onClick={() => navigate("/Quick")}
            >
              <FaCalendarCheck />
              Prendre Rendez-vous
            </Button>
            <Button 
              className="btn-outline-modern mobile-btn"
              onClick={() => navigate("/auth")}
            >
              <FaUser />
              Connexion
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Modal de rendez-vous */}
      <Modal
        show={showAppointmentModal}
        onHide={() => setShowAppointmentModal(false)}
        size="lg"
        centered
        className="appointment-modal-modern"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="p-0">
          <Quick />
        </Modal.Body>
      </Modal>

      <style jsx>{`
        /* ===== VARIABLES CSS MODERNES ===== */
        :root {
          /* Couleurs principales */
          --primary: #0070f3;
          --primary-dark: #0056b3;
          --primary-light: #3291ff;
          --secondary: #00c58e;
          --accent: #ff6b35;
          --success: #10b981;
          --danger: #ef4444;
          --warning: #f59e0b;
          --info: #06b6d4;

          /* Couleurs neutres */
          --dark: #1e293b;
          --medium: #64748b;
          --light: #94a3b8;
          --lighter: #e2e8f0;
          --lightest: #f8fafc;
          --white: #ffffff;

          /* Gradients */
          --gradient-primary: linear-gradient(135deg, #0070f3, #00c58e);
          --gradient-secondary: linear-gradient(135deg, #ff6b35, #f59e0b);
          --gradient-dark: linear-gradient(135deg, #1e293b, #334155);

          /* Typographie */
          --font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          --font-size-xs: 0.75rem;
          --font-size-sm: 0.875rem;
          --font-size-base: 1rem;
          --font-size-lg: 1.125rem;
          --font-size-xl: 1.25rem;
          --font-size-2xl: 1.5rem;
          --font-size-3xl: 1.875rem;
          --font-size-4xl: 2.25rem;
          --font-size-5xl: 3rem;

          /* Espacement */
          --spacing-1: 0.25rem;
          --spacing-2: 0.5rem;
          --spacing-3: 0.75rem;
          --spacing-4: 1rem;
          --spacing-5: 1.25rem;
          --spacing-6: 1.5rem;
          --spacing-8: 2rem;
          --spacing-10: 2.5rem;
          --spacing-12: 3rem;
          --spacing-16: 4rem;
          --spacing-20: 5rem;

          /* Bordures */
          --border-radius: 0.5rem;
          --border-radius-lg: 1rem;
          --border-radius-xl: 1.5rem;
          --border-radius-full: 9999px;

          /* Ombres */
          --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
          --shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          --shadow-md: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
          --shadow-xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

          /* Transitions */
          --transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          --transition-fast: 0.15s cubic-bezier(0.4, 0, 0.2, 1);
          --transition-slow: 0.5s cubic-bezier(0.4, 0, 0.2, 1);

          /* Z-index */
          --z-10: 10;
          --z-20: 20;
          --z-30: 30;
          --z-40: 40;
          --z-50: 50;
          --z-100: 100;

          /* Hauteurs */
          --header-height: 80px;
        }

        /* ===== STYLES GLOBAUX ===== */
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        html {
          scroll-behavior: smooth;
          overflow-x: hidden;
          width: 100%;
        }

        body {
          font-family: var(--font-family);
          color: var(--dark);
          background-color: var(--white);
          line-height: 1.6;
          overflow-x: hidden;
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .home-page {
          width: 100%;
          overflow-x: hidden;
          position: relative;
        }

        .home-page * {
          max-width: 100%;
        }

        .home-page .row {
          margin-left: 0;
          margin-right: 0;
        }

        .home-page .col,
        .home-page [class*="col-"] {
          padding-left: 12px;
          padding-right: 12px;
        }

        .container {
          width: 100%;
          max-width: 1280px;
          padding-left: 1.5rem;
          padding-right: 1.5rem;
          margin-left: auto;
          margin-right: auto;
          overflow-x: hidden;
        }

        /* ===== HEADER MODERNE ===== */
        .site-header {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          z-index: var(--z-100);
          transition: all var(--transition);
          padding: var(--spacing-4) 0;
          background-color: transparent;
          backdrop-filter: blur(10px);
        }

        .site-header.scrolled {
          background-color: rgba(255, 255, 255, 0.95);
          box-shadow: var(--shadow);
          padding: var(--spacing-3) 0;
        }

        .header-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .logo {
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .logo-icon {
          width: 50px;
          height: 50px;
          border-radius: var(--border-radius);
          overflow: hidden;
          margin-right: var(--spacing-3);
          box-shadow: var(--shadow);
        }

        .logo-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .logo-text {
          display: flex;
          flex-direction: column;
        }

        .logo-name {
          font-weight: 700;
          font-size: var(--font-size-lg);
          color: var(--white);
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        }

        .scrolled .logo-name {
          color: var(--dark);
          text-shadow: none;
        }

        .logo-tagline {
          font-size: var(--font-size-sm);
          color: rgba(255, 255, 255, 0.8);
          font-style: italic;
          font-weight: 500;
        }

        .scrolled .logo-tagline {
          color: var(--medium);
        }

        .main-nav ul {
          display: flex;
          align-items: center;
          gap: var(--spacing-8);
        }

        .main-nav a {
          color: var(--white);
          font-weight: 500;
          position: relative;
          padding: var(--spacing-2) var(--spacing-4);
          border-radius: var(--border-radius-full);
          transition: all var(--transition);
          text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        }

        .scrolled .main-nav a {
          color: var(--dark);
          text-shadow: none;
        }

        .main-nav a:hover,
        .main-nav li.active a {
          background-color: rgba(255, 255, 255, 0.1);
          transform: translateY(-2px);
        }

        .scrolled .main-nav a:hover,
        .scrolled .main-nav li.active a {
          background-color: var(--primary);
          color: var(--white);
        }

        .menu-toggle {
          width: 45px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--white);
          font-size: var(--font-size-lg);
          border-radius: var(--border-radius);
          background: var(--gradient-primary);
          box-shadow: var(--shadow);
          transition: all var(--transition);
        }

        .menu-toggle:hover {
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }

        /* ===== HERO SECTION RÉVOLUTIONNAIRE ===== */
        .hero-section {
          position: relative;
          height: 100vh;
          min-height: 900px;
          overflow: hidden;
          display: flex;
          align-items: center;
        }

        .hero-slider {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .hero-slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
          opacity: 0;
          transition: opacity 1.5s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .hero-slide.active {
          opacity: 1;
        }

        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            135deg,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(0, 112, 243, 0.3) 50%,
            rgba(0, 0, 0, 0.5) 100%
          );
        }

        .hero-content {
          position: relative;
          z-index: var(--z-20);
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-top: var(--header-height);
        }

        .hero-main-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: var(--spacing-12);
          align-items: center;
          margin-bottom: var(--spacing-8);
        }

        .hero-text h1 {
          font-size: var(--font-size-5xl);
          font-weight: 800;
          margin-bottom: var(--spacing-6);
          line-height: 1.1;
        }

        .text-white {
          color: var(--white);
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        }

        .hero-subtitle {
          background: var(--gradient-primary);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-size: var(--font-size-3xl) !important;
        }

        .hero-tagline {
          font-size: var(--font-size-xl);
          margin-bottom: var(--spacing-8);
          color: rgba(255, 255, 255, 0.9);
        }

        .hero-tagline span {
          color: var(--accent);
          font-weight: 600;
          margin: 0 var(--spacing-2);
        }

        .hero-actions {
          display: flex;
          gap: var(--spacing-4);
          flex-wrap: wrap;
        }

        .hero-btn {
          display: inline-flex;
          align-items: center;
          gap: var(--spacing-2);
          padding: var(--spacing-4) var(--spacing-8);
          border-radius: var(--border-radius-full);
          font-weight: 600;
          font-size: var(--font-size-base);
          transition: all var(--transition);
          text-decoration: none;
          border: none;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .btn-primary {
          background: var(--gradient-primary);
          color: var(--white);
          box-shadow: var(--shadow-lg);
        }

        .btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: var(--shadow-xl);
        }

        .btn-outline {
          background: rgba(255, 255, 255, 0.1);
          color: var(--white);
          border: 2px solid rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(10px);
        }

        .btn-outline:hover {
          background: rgba(255, 255, 255, 0.2);
          border-color: rgba(255, 255, 255, 0.5);
          transform: translateY(-3px);
        }

        /* ===== SPÉCIALITÉS SHOWCASE DANS LE HERO ===== */
        .hero-specialties-showcase {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border-radius: var(--border-radius-xl);
          padding: var(--spacing-8);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .specialties-header {
          text-align: center;
          margin-bottom: var(--spacing-6);
        }

        .specialties-header h3 {
          font-size: var(--font-size-2xl);
          color: var(--white);
          margin-bottom: var(--spacing-2);
          text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        }

        .specialties-header p {
          color: rgba(255, 255, 255, 0.8);
          font-size: var(--font-size-base);
        }

        .specialties-carousel {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-6);
        }

        .specialty-display {
          height: 200px;
          position: relative;
        }

        .active-specialty {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .specialty-card-hero {
          background: rgba(255, 255, 255, 0.95);
          border-radius: var(--border-radius-lg);
          padding: var(--spacing-6);
          height: 100%;
          display: flex;
          align-items: center;
          gap: var(--spacing-4);
          box-shadow: var(--shadow-lg);
          transition: all var(--transition);
        }

        .specialty-card-hero:hover {
          transform: translateY(-5px);
          box-shadow: var(--shadow-xl);
        }

        .specialty-icon-hero {
          width: 80px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: var(--font-size-3xl);
          background: rgba(0, 112, 243, 0.1);
          border-radius: var(--border-radius-lg);
          flex-shrink: 0;
        }

        .specialty-content-hero h4 {
          font-size: var(--font-size-xl);
          color: var(--dark);
          margin-bottom: var(--spacing-2);
        }

        .specialty-content-hero p {
          color: white;
          margin-bottom: var(--spacing-3);
          line-height: 1.6;
          opacity: 0.95;
        }

        .specialty-stats {
          display: flex;
          align-items: center;
          gap: var(--spacing-2);
          font-weight: 600;
          font-size: var(--font-size-sm);
        }

        .specialties-grid-mini {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--spacing-3);
          max-height: 300px;
          overflow-y: auto;
          overflow-x: hidden;
          padding-right: var(--spacing-2);
          scrollbar-width: thin;
          scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
        }

        /* Styles pour la scrollbar personnalisée */
        .specialties-grid-mini::-webkit-scrollbar {
          width: 6px;
        }

        .specialties-grid-mini::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 3px;
        }

        .specialties-grid-mini::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 3px;
        }

        .specialties-grid-mini::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.5);
        }

        .mini-specialty-card {
          background: rgba(255, 255, 255, 0.1);
          border: 2px solid rgba(255, 255, 255, 0.2);
          border-radius: var(--border-radius);
          padding: var(--spacing-3);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: var(--spacing-2);
          cursor: pointer;
          transition: all var(--transition);
          backdrop-filter: blur(10px);
        }

        .mini-specialty-card:hover,
        .mini-specialty-card.active {
          background: rgba(255, 255, 255, 0.2);
          border-color: rgba(255, 255, 255, 0.4);
          transform: translateY(-3px);
        }

        .mini-icon {
          font-size: var(--font-size-lg);
        }

        .mini-specialty-card span {
          color: var(--white);
          font-size: var(--font-size-xs);
          font-weight: 500;
          text-align: center;
        }

        .specialty-controls {
          display: flex;
          justify-content: center;
        }

        .control-btn {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          color: var(--white);
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all var(--transition);
          backdrop-filter: blur(10px);
        }

        .control-btn:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.1);
        }

        /* ===== CONTRÔLES DU SLIDER HERO ===== */
        .hero-slider-controls {
          position: absolute;
          bottom: var(--spacing-8);
          left: 50%;
          transform: translateX(-50%);
          z-index: var(--z-30);
        }

        .slider-dots {
          display: flex;
          gap: var(--spacing-2);
        }

        .slider-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.4);
          border: none;
          cursor: pointer;
          transition: all var(--transition);
        }

        .slider-dot.active {
          background: var(--white);
          transform: scale(1.3);
        }

        /* ===== SECTION INFORMATIONS PRATIQUES ===== */
        .info-section-modern {
          padding: var(--spacing-16) 0;
          background: linear-gradient(135deg, 
            rgba(0, 112, 243, 0.05) 0%, 
            rgba(255, 255, 255, 0.9) 50%, 
            rgba(0, 197, 142, 0.05) 100%
          );
          position: relative;
          z-index: var(--z-20);
        }

        .info-cards-grid-section {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: var(--spacing-8);
          max-width: 1200px;
          margin: 0 auto;
        }

        .info-section-modern .info-card-modern {
          background: var(--white);
          backdrop-filter: blur(20px);
          border-radius: var(--border-radius-xl);
          padding: var(--spacing-6);
          border: 1px solid rgba(0, 112, 243, 0.1);
          transition: all var(--transition);
          box-shadow: var(--shadow);
        }

        .info-section-modern .info-card-modern:hover {
          background: var(--white);
          transform: translateY(-8px);
          box-shadow: var(--shadow-lg);
          border-color: var(--primary);
        }

        .info-section-modern .card-header {
          display: flex;
          align-items: center;
          gap: var(--spacing-3);
          margin-bottom: var(--spacing-4);
        }

        .info-section-modern .icon-wrapper {
          width: 50px;
          height: 50px;
          border-radius: var(--border-radius-lg);
          background: var(--gradient-primary);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--white);
          font-size: var(--font-size-lg);
          box-shadow: var(--shadow);
        }

        .info-section-modern .card-header h4 {
          color: var(--dark);
          font-size: var(--font-size-lg);
          font-weight: 700;
          margin: 0;
        }

        .info-section-modern .card-content {
          color: var(--medium);
          font-size: var(--font-size-base);
        }

        .info-section-modern .schedule-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: var(--spacing-3);
          font-weight: 500;
        }

        .info-section-modern .time {
          background: linear-gradient(135deg, var(--primary), var(--secondary));
          color: var(--white);
          padding: var(--spacing-2) var(--spacing-3);
          border-radius: var(--border-radius);
          font-weight: 600;
          font-size: var(--font-size-sm);
        }

        .info-section-modern .time.closed {
          background: linear-gradient(135deg, var(--danger), #dc2626);
        }

        .info-section-modern .contact-number,
        .info-section-modern .wellness-item {
          display: flex;
          align-items: center;
          gap: var(--spacing-3);
          margin-bottom: var(--spacing-3);
          font-weight: 500;
        }

        .info-section-modern .contact-number svg {
          color: var(--primary);
          font-size: var(--font-size-base);
        }

        .info-section-modern .wellness-item {
          flex-direction: column;
          align-items: flex-start;
          gap: var(--spacing-1);
        }

        .info-section-modern .wellness-item span {
          font-weight: 700;
          color: var(--dark);
          font-size: var(--font-size-base);
        }

        .info-section-modern .wellness-item small {
          color: var(--medium);
          font-size: var(--font-size-sm);
        }

        /* ===== STYLES SPÉCIFIQUES POUR SNACK HEALTHY ===== */
        .info-section-modern .snack-healthy {
          position: relative;
          overflow: hidden;
        }

        .snack-image-container {
          width: 100%;
          height: 120px;
          border-radius: var(--border-radius);
          overflow: hidden;
          margin-bottom: var(--spacing-3);
          position: relative;
        }

        .snack-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform var(--transition);
        }

        .info-section-modern .snack-healthy:hover .snack-image {
          transform: scale(1.05);
        }

        .snack-image-container::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(45deg, rgba(0, 197, 142, 0.1), rgba(255, 107, 53, 0.1));
          z-index: 1;
        }

        .snack-info {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-2);
        }

        .snack-item {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-1);
        }

        /* ===== OVERLAY DE ZOOM POUR SNACK HEALTHY ===== */
        .snack-image-container {
          position: relative;
          overflow: hidden;
        }

        .zoom-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.5rem;
          opacity: 0;
          transition: opacity var(--transition);
          z-index: 2;
        }

        .snack-image-container:hover .zoom-overlay {
          opacity: 1;
        }

        .snack-image-container:hover .snack-image {
          transform: scale(1.1);
        }

        /* ===== STYLES POUR LE MODAL D'IMAGE ===== */
        .image-modal .modal-content {
          border: none;
          border-radius: 15px;
          overflow: hidden;
          background: var(--white);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }

        .image-modal .modal-header {
          background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
          color: white;
          padding: 1rem 1.5rem;
        }

        .image-modal .modal-title {
          font-weight: 600;
          font-size: 1.25rem;
        }

        .image-modal .btn-close {
          filter: brightness(0) invert(1);
        }

        .image-modal-content {
          position: relative;
        }

        .modal-image {
          width: 100%;
          height: auto;
          max-height: 60vh;
          object-fit: cover;
          border-radius: 0;
        }

        .image-info {
          padding: 1.5rem;
          background: var(--white);
        }

        .image-info h5 {
          color: var(--primary-color);
          font-weight: 600;
          margin-bottom: 0.75rem;
        }

        .image-info p {
          color: var(--text-light);
          line-height: 1.6;
          margin: 0;
        }

        /* ===== RESPONSIVE POUR LE MODAL ===== */
        @media (max-width: 768px) {
          .image-modal .modal-dialog {
            margin: 1rem;
          }
          
          .modal-image {
            max-height: 50vh;
          }
          
          .image-info {
            padding: 1rem;
          }
        }

        .snack-item span {
          font-weight: 700;
          color: var(--dark);
          font-size: var(--font-size-base);
        }

        .snack-item small {
          color: var(--secondary);
          font-size: var(--font-size-sm);
          font-weight: 500;
        }

        /* ===== SECTION SERVICES MODERNE ===== */
        .services-section-modern {
          padding: var(--spacing-16) 0;
          background: linear-gradient(135deg, var(--lightest) 0%, #e0f2fe 100%);
          position: relative;
          overflow: hidden;
        }

        .services-section-modern::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="%23e2e8f0" opacity="0.3"/><circle cx="75" cy="75" r="1" fill="%23cbd5e1" opacity="0.3"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>') repeat;
          opacity: 0.5;
          z-index: 1;
        }

        .services-section-modern .container {
          position: relative;
          z-index: 2;
        }

        .section-header-modern {
          text-align: center;
          max-width: 800px;
          margin: 0 auto var(--spacing-16);
        }

        .section-badge-modern {
          display: inline-block;
          background: var(--gradient-primary);
          color: var(--white);
          padding: var(--spacing-2) var(--spacing-6);
          border-radius: var(--border-radius-full);
          font-size: var(--font-size-sm);
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: var(--spacing-4);
          box-shadow: var(--shadow);
        }

        .section-header-modern h2 {
          font-size: var(--font-size-4xl);
          color: var(--dark);
          margin-bottom: var(--spacing-4);
          font-weight: 800;
        }

        .section-header-modern p {
          font-size: var(--font-size-lg);
          color: var(--medium);
          max-width: 600px;
          margin: 0 auto;
        }

        .services-grid-modern {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: var(--spacing-8);
          margin-bottom: var(--spacing-12);
        }

        .service-card-modern {
          position: relative;
          background: var(--white);
          border-radius: var(--border-radius-xl);
          overflow: hidden;
          box-shadow: var(--shadow-lg);
          transition: all var(--transition-slow);
          cursor: pointer;
        }

        .service-card-background {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4px;
          z-index: 1;
        }

        .service-card-content {
          position: relative;
          z-index: 2;
          padding: var(--spacing-8);
        }

        .service-header-modern {
          display: flex;
          align-items: flex-start;
          gap: var(--spacing-4);
          margin-bottom: var(--spacing-6);
        }

        .service-icon-modern {
          width: 70px;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: var(--font-size-2xl);
          border-radius: var(--border-radius-lg);
          flex-shrink: 0;
          transition: all var(--transition);
        }

        .service-title-section h3 {
          font-size: var(--font-size-xl);
          font-weight: 700;
          margin-bottom: var(--spacing-2);
        }

        .service-description {
          color: var(--medium);
          font-size: var(--font-size-base);
          line-height: 1.6;
          margin: 0;
        }

        .service-features {
          margin: var(--spacing-6) 0;
          padding: var(--spacing-6);
          background: var(--lightest);
          border-radius: var(--border-radius-lg);
          border: 2px solid rgba(0, 112, 243, 0.1);
        }

        .features-image-container {
          text-align: center;
          margin-bottom: 0;
        }

        .features-image-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
          max-width: 360px;
          margin: 0 auto;
          border-radius: var(--border-radius-xl);
          overflow: hidden;
          box-shadow: var(--shadow-xl);
          transition: all var(--transition);
        }

        .features-image-wrapper:hover {
          transform: translateY(-5px);
          box-shadow: var(--shadow-2xl);
        }

        .features-image-wrapper img {
          width: 100%;
          height: 360px;
          object-fit: cover;
          display: block;
          transition: all var(--transition);
        }

        .features-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 0.9) 0%,
            rgba(0, 0, 0, 0.7) 50%,
            rgba(0, 0, 0, 0.4) 70%,
            transparent 100%
          );
          padding: var(--spacing-6) var(--spacing-4) var(--spacing-4);
          color: var(--white);
          transform: translateY(100%);
          transition: all var(--transition);
        }

        .features-image-wrapper:hover .features-overlay {
          transform: translateY(0);
        }

        .features-overlay h4 {
          font-size: var(--font-size-lg);
          color: var(--white);
          margin-bottom: var(--spacing-3);
          font-weight: 700;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
          position: relative;
        }

        .features-overlay h4::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 50px;
          height: 3px;
          background: var(--primary);
          border-radius: var(--border-radius);
        }

        .features-overlay-list {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-2);
          margin-top: var(--spacing-4);
        }

        .overlay-feature-item {
          display: flex;
          align-items: flex-start;
          gap: var(--spacing-2);
          font-size: var(--font-size-sm);
          line-height: 1.4;
          opacity: 0.95;
          animation: fadeInUp 0.5s ease-out forwards;
          animation-delay: calc(var(--item-index, 0) * 0.1s);
          opacity: 0;
          transform: translateY(10px);
        }

        .overlay-feature-item:nth-child(1) { --item-index: 1; }
        .overlay-feature-item:nth-child(2) { --item-index: 2; }
        .overlay-feature-item:nth-child(3) { --item-index: 3; }
        .overlay-feature-item:nth-child(4) { --item-index: 4; }

        .overlay-feature-item svg {
          margin-top: 2px;
          flex-shrink: 0;
          font-size: var(--font-size-sm);
        }

        .overlay-more-features {
          margin-top: var(--spacing-2);
          padding-top: var(--spacing-2);
          border-top: 1px solid rgba(255, 255, 255, 0.3);
          text-align: center;
        }

        .overlay-more-features span {
          font-size: var(--font-size-xs);
          color: rgba(255, 255, 255, 0.8);
          font-weight: 600;
          background: rgba(0, 112, 243, 0.2);
          padding: var(--spacing-1) var(--spacing-2);
          border-radius: var(--border-radius);
        }

        .service-doctors-modern {
          margin: var(--spacing-6) 0;
          padding: var(--spacing-4);
          background: rgba(0, 112, 243, 0.05);
          border-radius: var(--border-radius);
          border-left: 4px solid var(--primary);
        }

        .service-doctors-modern h4 {
          display: flex;
          align-items: center;
          gap: var(--spacing-2);
          font-size: var(--font-size-base);
          font-weight: 600;
          margin-bottom: var(--spacing-3);
        }

        .doctors-list-modern {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-2);
        }

        .doctor-item-modern {
          display: flex;
          align-items: center;
          gap: var(--spacing-2);
          font-size: var(--font-size-sm);
          color: var(--medium);
          padding: var(--spacing-2);
          background: var(--white);
          border-radius: var(--border-radius);
        }

        .service-action {
          margin-top: var(--spacing-6);
        }

        .service-btn {
          display: inline-flex;
          align-items: center;
          gap: var(--spacing-2);
          padding: var(--spacing-3) var(--spacing-6);
          border-radius: var(--border-radius-full);
          color: var(--white);
          font-weight: 600;
          font-size: var(--font-size-sm);
          border: none;
          cursor: pointer;
          transition: all var(--transition);
        }

        .service-btn:hover {
          transform: translateY(-2px);
        }

        /* ===== SERVICES CTA ===== */
        .services-cta {
          text-align: center;
          background: var(--white);
          padding: var(--spacing-12);
          border-radius: var(--border-radius-xl);
          box-shadow: var(--shadow-lg);
        }

        .cta-content h3 {
          font-size: var(--font-size-3xl);
          color: var(--dark);
          margin-bottom: var(--spacing-4);
          font-weight: 700;
        }

        .cta-content p {
          font-size: var(--font-size-lg);
          color: var(--medium);
          margin-bottom: var(--spacing-8);
        }

        .cta-actions {
          display: flex;
          gap: var(--spacing-4);
          justify-content: center;
          flex-wrap: wrap;
        }

        .btn-primary-modern {
          display: inline-flex;
          align-items: center;
          gap: var(--spacing-2);
          background: var(--gradient-primary);
          color: var(--white);
          padding: var(--spacing-4) var(--spacing-8);
          border-radius: var(--border-radius-full);
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: all var(--transition);
          box-shadow: var(--shadow);
        }

        .btn-primary-modern:hover {
          transform: translateY(-3px);
          box-shadow: var(--shadow-lg);
        }

        .btn-outline-modern {
          display: inline-flex;
          align-items: center;
          gap: var(--spacing-2);
          background: transparent;
          color: var(--primary);
          padding: var(--spacing-4) var(--spacing-8);
          border-radius: var(--border-radius-full);
          font-weight: 600;
          border: 2px solid var(--primary);
          cursor: pointer;
          transition: all var(--transition);
        }

        .btn-outline-modern:hover {
          background: var(--primary);
          color: var(--white);
          transform: translateY(-3px);
        }

        /* ===== BOUTONS DE CONTRÔLE DES SERVICES ===== */
        .services-toggle-section {
          text-align: center;
          margin-top: var(--spacing-12);
          margin-bottom: var(--spacing-8);
        }

        .services-toggle-btn {
          display: inline-flex;
          align-items: center;
          gap: var(--spacing-3);
          background: var(--gradient-primary);
          color: var(--white);
          padding: var(--spacing-4) var(--spacing-8);
          border-radius: var(--border-radius-full);
          font-weight: 600;
          font-size: var(--font-size-base);
          border: none;
          cursor: pointer;
          transition: all var(--transition);
          box-shadow: var(--shadow);
          margin-bottom: var(--spacing-4);
        }

        .services-toggle-btn:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: var(--shadow-lg);
        }

        .services-toggle-btn.show-more {
          background: var(--gradient-primary);
        }

        .services-toggle-btn.show-less {
          background: var(--gradient-secondary);
        }

        .services-toggle-btn svg {
          font-size: var(--font-size-sm);
          transition: transform var(--transition);
        }

        .services-toggle-btn:hover svg {
          transform: translateY(2px);
        }

        .services-toggle-btn.show-less:hover svg {
          transform: translateY(-2px);
        }

        .services-counter {
          margin-top: var(--spacing-3);
        }

        .services-counter span {
          display: inline-block;
          background: rgba(0, 112, 243, 0.1);
          color: var(--primary);
          padding: var(--spacing-2) var(--spacing-4);
          border-radius: var(--border-radius-full);
          font-size: var(--font-size-sm);
          font-weight: 500;
          border: 1px solid rgba(0, 112, 243, 0.2);
        }

        /* ===== CARROUSEL D'IMAGES MODERNE ===== */
        .image-carousel-section-modern {
          padding: var(--spacing-20) 0;
          background: var(--white);
        }

        .image-carousel-container-modern {
          position: relative;
          max-width: 1000px;
          margin: 0 auto;
          border-radius: var(--border-radius-xl);
          overflow: hidden;
          box-shadow: var(--shadow-xl);
        }

        .image-carousel-wrapper-modern {
          position: relative;
          height: 600px;
          overflow: hidden;
        }

        .image-carousel-slide-modern {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .image-carousel-image-modern {
          position: relative;
          width: 100%;
          height: 100%;
        }

        .image-carousel-image-modern img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform var(--transition-slow);
        }

        .image-carousel-overlay-modern {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
          padding: var(--spacing-8);
          color: var(--white);
        }

        .overlay-content-modern h3 {
          font-size: var(--font-size-2xl);
          margin-bottom: var(--spacing-2);
          color: var(--white);
        }

        .overlay-content-modern p {
          font-size: var(--font-size-base);
          color: rgba(255, 255, 255, 0.9);
          margin: 0;
        }

        .image-carousel-controls-modern {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0 var(--spacing-4);
          z-index: var(--z-20);
        }

        .carousel-arrow-modern {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.9);
          color: var(--primary);
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: var(--font-size-lg);
          cursor: pointer;
          transition: all var(--transition);
          backdrop-filter: blur(10px);
        }

        .carousel-arrow-modern:hover {
          background: var(--primary);
          color: var(--white);
          transform: scale(1.1);
        }

        .image-carousel-indicators-modern {
          position: absolute;
          bottom: var(--spacing-4);
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: var(--spacing-2);
          z-index: var(--z-20);
        }

        .carousel-indicator-modern {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          border: none;
          cursor: pointer;
          transition: all var(--transition);
        }

        .carousel-indicator-modern.active {
          background: var(--white);
          transform: scale(1.3);
        }

        /* ===== SECTION À PROPOS MODERNE ===== */
        .about-section-modern {
          padding: var(--spacing-20) 0;
          background: linear-gradient(135deg, var(--lightest) 0%, #f0f9ff 100%);
        }

        .about-content-modern {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: var(--spacing-12);
          align-items: center;
        }

        .about-image-modern {
          position: relative;
          border-radius: var(--border-radius-xl);
          overflow: hidden;
          box-shadow: var(--shadow-xl);
        }

        .about-image-modern img {
          width: 100%;
          height: 500px;
          object-fit: cover;
          transition: transform var(--transition-slow);
        }

        .about-image-modern:hover img {
          transform: scale(1.05);
        }

        .image-overlay-about {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
          padding: var(--spacing-6);
        }

        .stats-overlay {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--spacing-4);
        }

        .stat-item {
          text-align: center;
          color: var(--white);
        }

        .stat-number {
          display: block;
          font-size: var(--font-size-2xl);
          font-weight: 800;
          margin-bottom: var(--spacing-1);
        }

        .stat-label {
          font-size: var(--font-size-sm);
          opacity: 0.9;
        }

        .about-text-modern h3 {
          font-size: var(--font-size-3xl);
          color: var(--dark);
          margin-bottom: var(--spacing-6);
          font-weight: 800;
          position: relative;
        }

        .about-text-modern h3::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 60px;
          height: 4px;
          background: var(--gradient-primary);
          border-radius: var(--border-radius);
        }

        .about-text-modern p {
          color: var(--medium);
          font-size: var(--font-size-base);
          line-height: 1.7;
          margin-bottom: var(--spacing-4);
        }

        .values-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: var(--spacing-4);
          margin-top: var(--spacing-8);
        }

        .value-item {
          display: flex;
          align-items: flex-start;
          gap: var(--spacing-3);
          padding: var(--spacing-4);
          background: var(--white);
          border-radius: var(--border-radius);
          box-shadow: var(--shadow);
          transition: all var(--transition);
        }

        .value-item:hover {
          transform: translateY(-3px);
          box-shadow: var(--shadow-md);
        }

        .value-item svg {
          color: var(--primary);
          font-size: var(--font-size-xl);
          margin-top: var(--spacing-1);
        }

        .value-item h4 {
          font-size: var(--font-size-base);
          color: var(--dark);
          margin-bottom: var(--spacing-1);
          font-weight: 600;
        }

        .value-item p {
          font-size: var(--font-size-sm);
          color: var(--medium);
          margin: 0;
        }

        /* ===== SECTION CONTACT MODERNE ===== */
        .contact-section-modern {
          padding: var(--spacing-20) 0;
          background: var(--white);
        }

        .contact-info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: var(--spacing-6);
          margin-bottom: var(--spacing-12);
        }

        .contact-card-modern {
          background: var(--white);
          padding: var(--spacing-8);
          border-radius: var(--border-radius-xl);
          box-shadow: var(--shadow);
          text-align: center;
          transition: all var(--transition);
          border-top: 4px solid var(--primary);
        }

        .contact-icon-modern {
          width: 70px;
          height: 70px;
          background: var(--gradient-primary);
          color: var(--white);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: var(--font-size-2xl);
          margin: 0 auto var(--spacing-4);
          transition: all var(--transition);
        }

        .contact-card-modern:hover .contact-icon-modern {
          transform: rotateY(180deg) scale(1.1);
        }

        .contact-card-modern h4 {
          font-size: var(--font-size-xl);
          color: var(--dark);
          margin-bottom: var(--spacing-3);
          font-weight: 700;
        }

        .contact-card-modern p,
        .contact-card-modern a {
          color: var(--medium);
          font-size: var(--font-size-base);
          text-decoration: none;
          transition: color var(--transition);
        }

        .contact-card-modern a:hover {
          color: var(--primary);
        }

        .phone-numbers {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-2);
        }

        .phone-numbers a {
          background: var(--lightest);
          padding: var(--spacing-2) var(--spacing-4);
          border-radius: var(--border-radius);
          transition: all var(--transition);
        }

        .phone-numbers a:hover {
          background: var(--primary);
          color: var(--white);
        }

        .schedule-info p {
          margin-bottom: var(--spacing-2);
        }

        .emergency-section {
          margin-top: var(--spacing-8);
        }

        .emergency-card {
          background: linear-gradient(135deg, #fee2e2, #fecaca);
          border: 2px solid #ef4444;
          border-radius: var(--border-radius-xl);
          padding: var(--spacing-8);
          display: flex;
          align-items: center;
          gap: var(--spacing-6);
          box-shadow: var(--shadow-lg);
        }

        .emergency-icon {
          width: 80px;
          height: 80px;
          background: var(--danger);
          color: var(--white);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: var(--font-size-3xl);
          flex-shrink: 0;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }

        .emergency-content h3 {
          font-size: var(--font-size-2xl);
          color: var(--danger);
          margin-bottom: var(--spacing-2);
          font-weight: 700;
        }

        .emergency-content p {
          color: var(--dark);
          margin-bottom: var(--spacing-4);
        }

        .emergency-numbers {
          display: flex;
          gap: var(--spacing-4);
        }

        .emergency-btn {
          display: inline-flex;
          align-items: center;
          gap: var(--spacing-2);
          background: var(--danger);
          color: var(--white);
          padding: var(--spacing-3) var(--spacing-6);
          border-radius: var(--border-radius-full);
          text-decoration: none;
          font-weight: 600;
          transition: all var(--transition);
        }

        .emergency-btn:hover {
          background: #dc2626;
          transform: translateY(-2px);
        }

        /* ===== SECTION COMMENTAIRES MODERNE ===== */
        .comments-section-modern {
          padding: var(--spacing-20) 0;
          background: linear-gradient(135deg, var(--lightest) 0%, #f0f9ff 100%);
        }

        .comments-wrapper-modern {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: var(--spacing-12);
          align-items: start;
        }

        .comment-form-section-modern {
          background: var(--white);
          padding: var(--spacing-8);
          border-radius: var(--border-radius-xl);
          box-shadow: var(--shadow-lg);
          border-top: 4px solid var(--primary);
        }

        .comment-form-section-modern h3 {
          font-size: var(--font-size-2xl);
          color: var(--dark);
          margin-bottom: var(--spacing-6);
          font-weight: 700;
        }

        .comment-form-modern {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-4);
        }

        .form-row-modern {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: var(--spacing-4);
        }

        .form-group-modern {
          display: flex;
          flex-direction: column;
        }

        .form-group-modern label {
          font-weight: 600;
          color: var(--dark);
          margin-bottom: var(--spacing-2);
          font-size: var(--font-size-sm);
        }

        .form-group-modern input,
        .form-group-modern textarea {
          padding: var(--spacing-3);
          border: 2px solid var(--lighter);
          border-radius: var(--border-radius);
          font-size: var(--font-size-base);
          transition: all var(--transition);
          font-family: inherit;
        }

        .form-group-modern input:focus,
        .form-group-modern textarea:focus {
          outline: none;
          border-color: var(--primary);
          box-shadow: 0 0 0 3px rgba(0, 112, 243, 0.1);
        }

        .rating-input-modern {
          display: flex;
          align-items: center;
          gap: var(--spacing-2);
        }

        .star {
          font-size: var(--font-size-lg);
          transition: all var(--transition);
        }

        .star.interactive:hover {
          transform: scale(1.2);
        }

        .rating-text {
          margin-left: var(--spacing-2);
          font-size: var(--font-size-sm);
          color: var(--medium);
          font-weight: 500;
        }

        .char-counter-modern {
          font-size: var(--font-size-xs);
          color: var(--medium);
          text-align: right;
          margin-top: var(--spacing-1);
        }

        .btn-submit-modern {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: var(--spacing-2);
          background: var(--gradient-primary);
          color: var(--white);
          padding: var(--spacing-4) var(--spacing-8);
          border-radius: var(--border-radius-full);
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: all var(--transition);
          box-shadow: var(--shadow);
        }

        .btn-submit-modern:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: var(--shadow-lg);
        }

        .btn-submit-modern:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid transparent;
          border-top: 2px solid currentColor;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .comment-message-modern {
          padding: var(--spacing-3);
          border-radius: var(--border-radius);
          font-size: var(--font-size-sm);
          font-weight: 500;
          margin-top: var(--spacing-2);
        }

        .comment-message-modern.success {
          background: #dcfce7;
          color: #166534;
          border: 1px solid #bbf7d0;
        }

        .comment-message-modern.error {
          background: #fee2e2;
          color: #991b1b;
          border: 1px solid #fecaca;
        }

        .comments-list-modern {
          background: var(--white);
          padding: var(--spacing-8);
          border-radius: var(--border-radius-xl);
          box-shadow: var(--shadow-lg);
          border-top: 4px solid var(--secondary);
        }

        .comments-header-modern {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: var(--spacing-6);
          padding-bottom: var(--spacing-4);
          border-bottom: 2px solid var(--lighter);
        }

        .comments-header-modern h3 {
          font-size: var(--font-size-2xl);
          color: var(--dark);
          font-weight: 700;
        }

        .comments-stats-modern {
          display: flex;
          gap: var(--spacing-4);
        }

        .stat-item-modern {
          text-align: center;
        }

        .stat-item-modern .stat-number {
          display: block;
          font-size: var(--font-size-xl);
          font-weight: 800;
          color: var(--primary);
        }

        .stat-item-modern .stat-label {
          font-size: var(--font-size-xs);
          color: var(--medium);
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .no-comments-modern {
          text-align: center;
          padding: var(--spacing-12) var(--spacing-4);
          color: var(--medium);
        }

        .no-comments-icon {
          font-size: var(--font-size-4xl);
          color: var(--lighter);
          margin-bottom: var(--spacing-4);
        }

        .no-comments-modern h4 {
          font-size: var(--font-size-xl);
          color: var(--dark);
          margin-bottom: var(--spacing-2);
        }

        .comments-grid-modern {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-4);
        }

        .comment-card-modern {
          background: var(--lightest);
          border-radius: var(--border-radius-lg);
          padding: var(--spacing-6);
          transition: all var(--transition);
          border-left: 4px solid var(--primary);
        }

        .comment-header-modern {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: var(--spacing-4);
        }

        .comment-author-modern {
          display: flex;
          align-items: center;
          gap: var(--spacing-3);
        }

        .author-avatar-modern {
          width: 50px;
          height: 50px;
          background: var(--gradient-primary);
          color: var(--white);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: var(--font-size-lg);
          font-weight: 700;
        }

        .author-info-modern h4 {
          font-size: var(--font-size-base);
          color: var(--dark);
          margin-bottom: var(--spacing-1);
          font-weight: 600;
        }

        .comment-rating-modern {
          display: flex;
          gap: 2px;
        }

        .comment-date-modern {
          font-size: var(--font-size-xs);
          color: var(--medium);
          background: var(--white);
          padding: var(--spacing-1) var(--spacing-2);
          border-radius: var(--border-radius);
        }

        .comment-content-modern {
          position: relative;
          padding: var(--spacing-4);
          background: var(--white);
          border-radius: var(--border-radius);
          font-style: italic;
        }

        .quote-icon {
          color: var(--primary);
          opacity: 0.3;
          font-size: var(--font-size-sm);
        }

        .quote-icon-end {
          float: right;
          color: var(--primary);
          opacity: 0.3;
          font-size: var(--font-size-sm);
        }

        .comment-content-modern p {
          margin: var(--spacing-2) 0;
          color: var(--dark);
          line-height: 1.6;
        }

        .more-comments-info-modern {
          text-align: center;
          margin-top: var(--spacing-6);
          padding-top: var(--spacing-4);
          border-top: 1px solid var(--lighter);
        }

        .more-comments-info-modern p {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: var(--spacing-2);
          color: var(--medium);
          font-size: var(--font-size-sm);
        }

        /* ===== SECTION ÉQUIPE DE DÉVELOPPEMENT MODERNE ===== */
        .dev-team-section-modern {
          padding: var(--spacing-20) 0;
          background: var(--white);
        }

        .dev-team-showcase {
          max-width: 800px;
          margin: 0 auto;
        }

        .dev-team-carousel-modern {
          position: relative;
        }

        .dev-team-card-modern {
          background: var(--white);
          border-radius: var(--border-radius-xl);
          overflow: hidden;
          box-shadow: var(--shadow-xl);
          cursor: pointer;
          transition: all var(--transition);
          border: 2px solid transparent;
        }

        .dev-team-card-modern:hover {
          border-color: var(--primary);
          transform: translateY(-5px);
          box-shadow: var(--shadow-xl);
        }

        .dev-team-image-modern {
          position: relative;
          height: 300px;
          overflow: hidden;
        }

        .dev-team-image-modern img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform var(--transition-slow);
        }

        .dev-team-card-modern:hover .dev-team-image-modern img {
          transform: scale(1.1);
        }

        .dev-team-overlay-modern {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 112, 243, 0.9);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: var(--white);
          opacity: 0;
          transition: all var(--transition);
        }

        .dev-team-card-modern:hover .dev-team-overlay-modern {
          opacity: 1;
        }

        .dev-team-overlay-modern svg {
          font-size: var(--font-size-3xl);
          margin-bottom: var(--spacing-2);
        }

        .dev-team-content-modern {
          padding: var(--spacing-8);
          text-align: center;
        }

        .dev-team-content-modern h3 {
          font-size: var(--font-size-2xl);
          color: var(--dark);
          margin-bottom: var(--spacing-4);
          font-weight: 700;
        }

        .dev-team-role-modern {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: var(--spacing-2);
          margin-bottom: var(--spacing-4);
          color: var(--primary);
          font-weight: 600;
        }

        .dev-team-content-modern p {
          color: var(--medium);
          margin-bottom: var(--spacing-6);
          line-height: 1.6;
        }

        .dev-team-cta {
          display: inline-flex;
          align-items: center;
          gap: var(--spacing-2);
          background: var(--gradient-primary);
          color: var(--white);
          padding: var(--spacing-3) var(--spacing-6);
          border-radius: var(--border-radius-full);
          font-weight: 600;
          font-size: var(--font-size-sm);
          transition: all var(--transition);
        }

        .dev-team-cta:hover {
          transform: translateY(-2px);
        }

        .dev-team-controls-modern {
          display: flex;
          justify-content: center;
          margin-top: var(--spacing-6);
        }

        .dev-team-dots-modern {
          display: flex;
          gap: var(--spacing-2);
        }

        .dev-team-dot-modern {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: var(--lighter);
          border: none;
          cursor: pointer;
          transition: all var(--transition);
        }

        .dev-team-dot-modern.active {
          background: var(--primary);
          transform: scale(1.3);
        }

        /* ===== SECTION CARTE MODERNE ===== */
        .map-section-modern {
          padding: var(--spacing-16) 0;
          background: var(--lightest);
        }

        .map-container-modern {
          position: relative;
          border-radius: var(--border-radius-xl);
          overflow: hidden;
          box-shadow: var(--shadow-xl);
        }

        .map-container-modern iframe {
          filter: grayscale(20%);
          transition: filter var(--transition);
        }

        .map-container-modern:hover iframe {
          filter: grayscale(0%);
        }

        .map-header-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: var(--spacing-8);
          margin-top: var(--spacing-4);
        }

        .map-header-content p {
          flex: 1;
          font-size: var(--font-size-lg);
          color: var(--medium);
          margin: 0;
        }

        .map-info-inline {
          flex-shrink: 0;
        }

        .map-info-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          padding: var(--spacing-4);
          border-radius: var(--border-radius);
          box-shadow: var(--shadow);
          max-width: 250px;
        }

        .map-info-card h4 {
          font-size: var(--font-size-base);
          color: var(--dark);
          margin-bottom: var(--spacing-2);
          font-weight: 600;
        }

        .map-info-card p {
          font-size: var(--font-size-sm);
          color: var(--medium);
          margin-bottom: var(--spacing-2);
        }

        .map-contact {
          display: flex;
          align-items: center;
          gap: var(--spacing-2);
          color: var(--primary);
          font-weight: 500;
          font-size: var(--font-size-sm);
        }

        .map-actions {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-2);
          margin-top: var(--spacing-3);
        }

        .directions-btn,
        .view-larger-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: var(--spacing-2);
          padding: var(--spacing-2) var(--spacing-3);
          border: none;
          border-radius: var(--border-radius);
          font-size: var(--font-size-sm);
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .directions-btn {
          background: var(--primary);
          color: var(--white);
        }

        .directions-btn:hover {
          background: var(--primary-dark);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(26, 188, 156, 0.3);
        }

        .view-larger-btn {
          background: var(--white);
          color: var(--primary);
          border: 1px solid var(--primary);
        }

        .view-larger-btn:hover {
          background: var(--primary);
          color: var(--white);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(26, 188, 156, 0.3);
        }

        /* ===== FOOTER MODERNE ===== */
        .site-footer-modern {
          background: var(--dark);
          color: var(--white);
          padding: var(--spacing-16) 0 var(--spacing-8);
        }

        .footer-content-modern {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-8);
        }

        .footer-main {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.5fr;
          gap: var(--spacing-8);
        }

        .footer-logo-modern {
          display: flex;
          align-items: center;
          gap: var(--spacing-3);
          margin-bottom: var(--spacing-4);
        }

        .footer-logo-modern img {
          width: 50px;
          height: 50px;
          border-radius: var(--border-radius);
        }

        .logo-text-modern {
          display: flex;
          flex-direction: column;
        }

        .logo-name-modern {
          font-size: var(--font-size-lg);
          font-weight: 700;
          color: var(--white);
        }

        .logo-tagline-modern {
          font-size: var(--font-size-xs);
          color: var(--light);
          font-style: italic;
        }

        .footer-description {
          color: var(--light);
          line-height: 1.6;
          margin-bottom: var(--spacing-4);
        }

        .footer-specialties {
          display: flex;
          gap: var(--spacing-2);
          flex-wrap: wrap;
        }

        .footer-specialties span {
          background: var(--primary);
          color: var(--white);
          padding: var(--spacing-1) var(--spacing-3);
          border-radius: var(--border-radius-full);
          font-size: var(--font-size-xs);
          font-weight: 500;
        }

        .footer-links-modern h4,
        .footer-services-modern h4,
        .footer-contact-modern h4 {
          font-size: var(--font-size-lg);
          color: var(--white);
          margin-bottom: var(--spacing-4);
          font-weight: 600;
          position: relative;
        }

        .footer-links-modern h4::after,
        .footer-services-modern h4::after,
        .footer-contact-modern h4::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 30px;
          height: 2px;
          background: var(--primary);
        }

        .footer-links-modern ul,
        .footer-services-modern ul {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-2);
        }

        .footer-links-modern a,
        .footer-services-modern li {
          color: var(--light);
          text-decoration: none;
          transition: color var(--transition);
          cursor: pointer;
        }

        .footer-links-modern a:hover {
          color: var(--primary);
        }

        .footer-contact-item {
          display: flex;
          align-items: center;
          gap: var(--spacing-3);
          margin-bottom: var(--spacing-3);
          color: var(--light);
        }

        .footer-contact-item svg {
          color: var(--primary);
          font-size: var(--font-size-base);
        }

        .footer-bottom-modern {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: var(--spacing-8);
          border-top: 1px solid var(--medium);
        }

        .footer-copyright {
          color: var(--light);
          font-size: var(--font-size-sm);
        }

        .footer-credits-modern {
          color: var(--light);
          font-size: var(--font-size-sm);
        }

        .footer-credits-modern a {
          color: var(--primary);
          text-decoration: none;
          font-weight: 600;
        }

        .footer-credits-modern a:hover {
          text-decoration: underline;
        }

        /* ===== BOUTONS FLOTTANTS MODERNES ===== */
        .floating-buttons-modern {
          position: fixed;
          bottom: var(--spacing-6);
          right: var(--spacing-6);
          display: flex;
          flex-direction: column;
          gap: var(--spacing-3);
          z-index: var(--z-50);
        }

        .floating-appointment-modern,
        .floating-login-modern {
          display: flex;
          align-items: center;
          gap: var(--spacing-2);
          padding: var(--spacing-3) var(--spacing-4);
          border-radius: var(--border-radius-full);
          color: var(--white);
          font-weight: 600;
          font-size: var(--font-size-sm);
          cursor: pointer;
          transition: all var(--transition);
          box-shadow: var(--shadow-lg);
          backdrop-filter: blur(10px);
        }

        .floating-appointment-modern {
          background: var(--gradient-primary);
        }

        .floating-login-modern {
          background: var(--gradient-secondary);
        }

        .floating-appointment-modern:hover,
        .floating-login-modern:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: var(--shadow-xl);
        }

        /* ===== MENU MOBILE MODERNE ===== */
        .mobile-nav-modern ul {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-4);
          margin-bottom: var(--spacing-8);
        }

        .mobile-nav-modern a {
          display: block;
          padding: var(--spacing-4);
          color: var(--dark);
          font-weight: 600;
          text-decoration: none;
          border-radius: var(--border-radius);
          transition: all var(--transition);
          cursor: pointer;
        }

        .mobile-nav-modern a:hover {
          background: var(--lightest);
          color: var(--primary);
        }

        .mobile-actions-modern {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-3);
        }

        .mobile-btn {
          width: 100%;
          justify-content: center;
        }

        /* ===== MODAL MODERNE ===== */
        .appointment-modal-modern .modal-content {
          border-radius: var(--border-radius-xl);
          border: none;
          box-shadow: var(--shadow-xl);
        }

        /* ===== RESPONSIVE DESIGN ===== */
        @media (max-width: 1200px) {
          .hero-main-content {
            grid-template-columns: 1fr;
            gap: var(--spacing-8);
            text-align: center;
          }

          .about-content-modern {
            grid-template-columns: 1fr;
            gap: var(--spacing-8);
          }

          .comments-wrapper-modern {
            grid-template-columns: 1fr;
            gap: var(--spacing-8);
          }

          .footer-main {
            grid-template-columns: repeat(2, 1fr);
            gap: var(--spacing-6);
          }
        }

        @media (max-width: 1024px) {
          .info-cards-grid-section {
            grid-template-columns: repeat(2, 1fr);
            gap: var(--spacing-6);
            max-width: 800px;
          }

          .snack-image-container {
            height: 100px;
          }
        }

        @media (max-width: 768px) {
          :root {
            --font-size-5xl: 2.5rem;
            --font-size-4xl: 2rem;
            --font-size-3xl: 1.5rem;
            --font-size-2xl: 1.25rem;
          }

          .logo-tagline {
            font-size: var(--font-size-base);
            font-weight: 600;
          }

          .container {
            padding-left: 1rem;
            padding-right: 1rem;
          }

          .hero-section {
            min-height: 100vh;
            height: auto;
            padding: 90px 0 50px 0;
            display: flex;
            align-items: center;
          }

          .hero-content {
            flex-direction: column;
            gap: var(--spacing-8);
            text-align: center;
            padding: var(--spacing-6) 0;
            width: 100%;
          }

          .hero-main-content {
            width: 100%;
            max-width: none;
            margin-bottom: var(--spacing-6);
            order: 1;
          }

          .hero-specialties-showcase {
            width: 100%;
            max-width: none;
            margin-top: 0;
            order: 2;
            background: rgba(255, 255, 255, 0.05);
            backdrop-filter: blur(10px);
            border-radius: 20px;
            padding: var(--spacing-4);
            margin: 0 var(--spacing-4);
          }

          .hero-text h1 {
            font-size: 2.2rem;
            line-height: 1.1;
            margin-bottom: var(--spacing-6);
            font-weight: 700;
          }

          .hero-subtitle {
            font-size: 1.4rem !important;
          }

          .hero-tagline {
            font-size: 1.1rem;
            margin-bottom: var(--spacing-8);
            padding: 0 var(--spacing-4);
            line-height: 1.6;
            font-weight: 400;
          }

          .hero-actions {
            flex-direction: column;
            align-items: center;
            gap: var(--spacing-4);
            width: 100%;
            padding: 0 var(--spacing-4);
          }

          .hero-btn {
            width: 100%;
            max-width: 320px;
            justify-content: center;
            padding: var(--spacing-4) var(--spacing-6);
            font-size: 1rem;
            font-weight: 600;
            border-radius: 50px;
            min-height: 56px;
            display: flex;
            align-items: center;
            gap: var(--spacing-2);
          }

          .hero-btn.btn-primary {
            background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
            border: none;
            box-shadow: 0 8px 20px rgba(0, 123, 191, 0.3);
          }

          .hero-btn.btn-outline {
            background: rgba(255, 255, 255, 0.1);
            border: 2px solid rgba(255, 255, 255, 0.3);
            color: white;
            backdrop-filter: blur(10px);
          }

          .specialties-header h3 {
            font-size: 1.5rem;
            margin-bottom: var(--spacing-3);
            color: white;
            font-weight: 600;
          }

          .specialties-header p {
            font-size: 0.95rem;
            margin-bottom: var(--spacing-4);
            padding: 0;
            color: rgba(255, 255, 255, 0.8);
          }

          /* Garder la grande carte spécialité et masquer la grille mini sur tablette */
          .specialty-display {
            display: block;
            margin-bottom: var(--spacing-4);
          }

          .active-specialty {
            padding: var(--spacing-4);
            margin: 0;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 15px;
            border: 1px solid rgba(255, 255, 255, 0.2);
          }

          .specialty-icon-hero {
            font-size: 2rem;
            margin-bottom: var(--spacing-3);
          }

          .specialty-content-hero h4 {
            font-size: 1.2rem;
            margin-bottom: var(--spacing-2);
            font-weight: 600;
          }

          .specialty-content-hero p {
            font-size: 0.9rem;
            margin-bottom: var(--spacing-3);
            line-height: 1.5;
            color: white;
            opacity: 0.95;
          }

          .specialty-stats {
            font-size: 0.8rem;
            color: rgba(255, 255, 255, 0.7);
            font-weight: 500;
          }

          .specialties-carousel .specialty-controls {
            display: none;
          }

          /* Masquer la grille mini sur tablette */
          .specialties-grid-mini {
            display: none;
          }

          .specialty-mini {
            padding: var(--spacing-3);
            text-align: center;
            background: rgba(255, 255, 255, 0.08);
            border-radius: 12px;
            transition: all 0.3s ease;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }

          .specialty-mini:hover {
            background: rgba(255, 255, 255, 0.15);
            transform: translateY(-2px);
          }

          .specialty-mini .icon {
            font-size: 1.2rem;
            margin-bottom: var(--spacing-2);
          }

          .specialty-mini .name {
            font-size: 0.75rem;
            line-height: 1.3;
            font-weight: 500;
          }

          .services-grid-modern {
            grid-template-columns: 1fr;
            gap: var(--spacing-6);
          }

          .services-section-modern {
            padding: var(--spacing-12) 0;
          }

          .services-toggle-section {
            margin-top: var(--spacing-8);
            margin-bottom: var(--spacing-6);
          }

          .services-toggle-btn {
            padding: var(--spacing-3) var(--spacing-6);
            font-size: var(--font-size-sm);
          }

          .contact-info-grid {
            grid-template-columns: 1fr;
            gap: var(--spacing-4);
          }

          .emergency-card {
            flex-direction: column;
            text-align: center;
            gap: var(--spacing-4);
          }

          .emergency-numbers {
            flex-direction: column;
            width: 100%;
          }

          .emergency-btn {
            width: 100%;
            justify-content: center;
          }

          .form-row-modern {
            grid-template-columns: 1fr;
          }

          .values-grid {
            grid-template-columns: 1fr;
          }

          .footer-main {
            grid-template-columns: 1fr;
            gap: var(--spacing-6);
          }

          .footer-bottom-modern {
            flex-direction: column;
            gap: var(--spacing-4);
            text-align: center;
          }

          .floating-buttons-modern {
            bottom: var(--spacing-4);
            right: var(--spacing-4);
          }

          .floating-appointment-modern span,
          .floating-login-modern span {
            display: none;
          }

          .floating-appointment-modern,
          .floating-login-modern {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            padding: 0;
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .hero-section {
            min-height: 100vh;
            padding: 80px 0 40px 0;
            display: flex;
            align-items: center;
          }

          .hero-content {
            gap: var(--spacing-6);
            padding: var(--spacing-4) 0;
          }

          .hero-specialties-showcase {
            padding: var(--spacing-3);
            margin: 0 var(--spacing-2);
          }

          .hero-text h1 {
            font-size: 1.8rem;
            line-height: 1.1;
            margin-bottom: var(--spacing-5);
          }

          .hero-subtitle {
            font-size: 1.1rem !important;
          }

          .hero-tagline {
            font-size: 0.95rem;
            margin-bottom: var(--spacing-6);
            padding: 0 var(--spacing-2);
          }

          .hero-actions {
            gap: var(--spacing-3);
            padding: 0 var(--spacing-2);
          }

          .hero-btn {
            max-width: 300px;
            padding: var(--spacing-3) var(--spacing-5);
            font-size: 0.9rem;
            min-height: 50px;
          }

          .specialties-header h3 {
            font-size: 1.25rem;
            margin-bottom: var(--spacing-2);
          }

          .specialties-header p {
            font-size: 0.85rem;
            margin-bottom: var(--spacing-3);
          }

          /* Garder la grande carte spécialité et masquer la grille mini sur smartphone */
          .specialty-display {
            display: block;
            margin-bottom: var(--spacing-3);
          }

          .active-specialty {
            padding: var(--spacing-3);
            margin: 0;
          }

          .specialty-icon-hero {
            font-size: 1.5rem;
            margin-bottom: var(--spacing-2);
          }

          .specialty-content-hero h4 {
            font-size: 1rem;
            margin-bottom: var(--spacing-2);
          }

          .specialty-content-hero p {
            font-size: 0.8rem;
            margin-bottom: var(--spacing-2);
            line-height: 1.4;
            color: white;
            opacity: 0.95;
          }

          .specialty-stats {
            font-size: 0.7rem;
          }

          .specialties-carousel .specialty-controls {
            display: none;
          }

          /* Masquer la grille mini sur smartphone */
          .specialties-grid-mini {
            display: none;
          }

          .specialty-mini {
            padding: var(--spacing-2);
          }

          .specialty-mini .icon {
            font-size: 1rem;
            margin-bottom: var(--spacing-1);
          }

          .specialty-mini .name {
            font-size: 0.7rem;
            line-height: 1.2;
          }

          .info-section-modern {
            padding: var(--spacing-8) 0;
          }

          .info-section-modern .info-card-modern {
            padding: var(--spacing-4);
          }

          .info-section-modern .card-header {
            flex-direction: column;
            text-align: center;
            gap: var(--spacing-2);
          }

          .info-section-modern .icon-wrapper {
            width: 40px;
            height: 40px;
            font-size: var(--font-size-base);
          }

          .features-image-wrapper {
            max-width: 280px;
          }

          .features-image-wrapper img {
            height: 280px;
          }

          .features-overlay {
            padding: var(--spacing-4) var(--spacing-3) var(--spacing-3);
          }

          .features-overlay h4 {
            font-size: var(--font-size-base);
            margin-bottom: var(--spacing-2);
          }

          .overlay-feature-item {
            font-size: var(--font-size-xs);
          }

          .features-image-wrapper {
            max-width: 180px;
          }

          .features-image-wrapper img {
            height: 180px;
          }

          .features-overlay {
            padding: var(--spacing-2) var(--spacing-2) var(--spacing-2);
          }

          .features-overlay h4 {
            font-size: var(--font-size-xs);
            margin-bottom: var(--spacing-1);
          }

          .overlay-feature-item {
            font-size: 10px;
            gap: var(--spacing-1);
          }

          .overlay-feature-item svg {
            font-size: 10px;
          }

          .cta-actions {
            flex-direction: column;
            align-items: center;
          }

          .btn-primary-modern,
          .btn-outline-modern {
            width: 100%;
            justify-content: center;
          }
        }

        /* ===== ANIMATIONS SUPPLÉMENTAIRES ===== */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.6s ease-out;
        }

        .animate-slideInLeft {
          animation: slideInLeft 0.6s ease-out;
        }

        .animate-slideInRight {
          animation: slideInRight 0.6s ease-out;
        }

        /* ===== UTILITAIRES ===== */
        .text-center { text-align: center; }
        .text-left { text-align: left; }
        .text-right { text-align: right; }

        .d-flex { display: flex; }
        .d-grid { display: grid; }
        .d-none { display: none; }
        .d-block { display: block; }

        .align-items-center { align-items: center; }
        .align-items-start { align-items: flex-start; }
        .align-items-end { align-items: flex-end; }

        .justify-content-center { justify-content: center; }
        .justify-content-between { justify-content: space-between; }
        .justify-content-around { justify-content: space-around; }

        .flex-column { flex-direction: column; }
        .flex-row { flex-direction: row; }

        .gap-1 { gap: var(--spacing-1); }
        .gap-2 { gap: var(--spacing-2); }
        .gap-3 { gap: var(--spacing-3); }
        .gap-4 { gap: var(--spacing-4); }
        .gap-6 { gap: var(--spacing-6); }
        .gap-8 { gap: var(--spacing-8); }

        .m-0 { margin: 0; }
        .mb-2 { margin-bottom: var(--spacing-2); }
        .mb-4 { margin-bottom: var(--spacing-4); }
        .mb-6 { margin-bottom: var(--spacing-6); }
        .mb-8 { margin-bottom: var(--spacing-8); }

        .p-0 { padding: 0; }
        .p-4 { padding: var(--spacing-4); }
        .p-6 { padding: var(--spacing-6); }
        .p-8 { padding: var(--spacing-8); }

        .w-full { width: 100%; }
        .h-full { height: 100%; }

        .rounded { border-radius: var(--border-radius); }
        .rounded-lg { border-radius: var(--border-radius-lg); }
        .rounded-xl { border-radius: var(--border-radius-xl); }
        .rounded-full { border-radius: var(--border-radius-full); }

        .shadow { box-shadow: var(--shadow); }
        .shadow-md { box-shadow: var(--shadow-md); }
        .shadow-lg { box-shadow: var(--shadow-lg); }
        .shadow-xl { box-shadow: var(--shadow-xl); }

        .transition { transition: all var(--transition); }
        .transition-fast { transition: all var(--transition-fast); }
        .transition-slow { transition: all var(--transition-slow); }

        .cursor-pointer { cursor: pointer; }
        .cursor-not-allowed { cursor: not-allowed; }

        .overflow-hidden { overflow: hidden; }
        .overflow-auto { overflow: auto; }

        .relative { position: relative; }
        .absolute { position: absolute; }
        .fixed { position: fixed; }

        .z-10 { z-index: var(--z-10); }
        .z-20 { z-index: var(--z-20); }
        .z-30 { z-index: var(--z-30); }
        .z-40 { z-index: var(--z-40); }
        .z-50 { z-index: var(--z-50); }

        /* ===== ÉTATS DE FOCUS ET ACCESSIBILITÉ ===== */
        *:focus {
          outline: 2px solid var(--primary);
          outline-offset: 2px;
        }

        button:focus,
        a:focus {
          outline: 2px solid var(--primary);
          outline-offset: 2px;
        }

        /* ===== STYLES POUR L'IMPRESSION ===== */
        @media print {
          .site-header,
          .floating-buttons-modern,
          .hero-slider-controls,
          .image-carousel-controls-modern,
          .dev-team-controls-modern {
            display: none !important;
          }

          .hero-section {
            height: auto !important;
            min-height: auto !important;
          }

          body {
            background: white !important;
            color: black !important;
          }

          .service-card-modern,
          .contact-card-modern,
          .comment-card-modern {
            break-inside: avoid;
          }
        }

        /* ===== STYLES POUR LES PRÉFÉRENCES UTILISATEUR ===== */
        @media (prefers-reduced-motion: reduce) {
          *,
          *::before,
          *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
          }
        }

        @media (prefers-color-scheme: dark) {
          /* Styles pour le mode sombre si nécessaire */
        }

        /* ===== STYLES POUR LES ÉCRANS HAUTE RÉSOLUTION ===== */
        @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
          .logo-image,
          .about-image-modern img,
          .dev-team-image-modern img {
            image-rendering: -webkit-optimize-contrast;
            image-rendering: crisp-edges;
          }
        }
      `}</style>

      {/* Modal pour afficher l'image snack healthy en grand */}
      <Modal
        show={showImageModal}
        onHide={handleCloseImageModal}
        size="lg"
        centered
        className="image-modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>Snack Healthy</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="image-modal-content">
            <img 
              src={monImage12} 
              alt="Snack Healthy - Image agrandie" 
              className="modal-image"
            />
            <div className="image-info">
              <h5>Nos Collations Saines</h5>
              <p>Découvrez notre sélection de snacks healthy, parfaits pour une alimentation équilibrée et savoureuse.</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Home;
